import './video.css';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import PlayerControls from '../../playerDomain/components/PlayerControls';
import PlayerControlsLegacy from '../PlayerControls/PlayerControls';

import Epg from '../../containers/Epg';
import store from '../../store';
import {
    showNotification,
    showPlayerEventRecordingNotAvailableNotification,
} from './../../actions/notification';
import { navigateFrom } from './../../actions/epg';
import { setResumeData } from './../../actions/resume';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import Translator from '../../requests/apa/Translator';
import * as api from '../../requests/loader';
import FallbackUtil from './FallbackUtil';
import FallbackHelper from './../../AAFPlayer/helpers/FallbackHelper';

import {
    checkFavoriteContent,
    configSetupPlay,
    showModalSinglePlay,
} from '../../actions/musica/player-shared-action-creators';

import { playFullMedia } from '../../actions/playmedia';
import * as playerConstant from '../../utils/playerConstants';
import Utils from './../../utils/Utils';
import TvChannelUtil from '../../utils/TvChannelUtil';
import LayersControl from './../../utils/LayersControl';
import VirtualSubtitles from './VirtualSubtitles';
import PlayerSubtitlesTask from '../../requests/tasks/player/PlayerSubtitlesTask';
import RequestManager from '../../requests/RequestManager';
import settings, { IPTV } from '../../devices/all/settings';
import getAppConfig from '../../config/appConfig';
import {
    showModal,
    HIDE_MODAL,
    MODAL_END_PLAYER,
    MODAL_END_PLAYER2,
    AAF_MODAL_ERROR,
    MODAL_PIN,
    MODAL_REINTENTO,
    MODAL_DESCONEXION,
    MODAL_CHANGING_EPISODE,
    MODAL_DEVICES_EXCEEDED,
    MODAL_END_PLAYER_CATCHUP,
    AAF_MODAL_PLAY_OPTIONS,
    MODAL_INACTIVITY,
    MODAL_OPTIONS_EPISODES,
    MODAL_KEEP_WATCHING
} from '../../actions/modal';
import Device from '../../devices/device';
import ChannelSingleton from '../Epg/ChannelsSingleton';
import { PONCONNECT, PONSTOP, PONPLAY, PONPAUSE } from '../../devices/all/settings';
import DeviceNetworkStatus from '../../utils/DeviceNetworkStatus';

import MusicContainer from '../MusicaPlayer';

import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import Metadata from '../../requests/apa/Metadata';
import { Dates } from '../../packages/dates';
import PlayerWatermark from './PlayerWatermark';
import ModalEpgUtils from '../Epg/ModalEpgUtils';

import {
    AAFPLAYER_STOP,
    AAFPLAYER_PLAY,
    AAF_CONTENT_IS_VOD,
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TIMESHIFT,
    AAF_CONTENT_IS_TV,
    AAF_CONTENT_IS_NPVR,
    AAF_CONTENT_IS_RADIO,
    AAF_CONTENT_IS_AUDIO,
} from '../../AAFPlayer/constants';

import TrackerManager from '../../utils/TrackerManager';
import AkamaiTracker from '../../utils/trackers/AkamaiTracker';
import PlayerTracker from '../../utils/trackers/PlayerTracker';
import DashboardTracker from '../../utils/trackers/DashboardTracker';

import YouboraTracker from '../../utils/trackers/YouboraTracker';

import {
    isPreviewSong,
    sendMetricsMusicaStarted,
} from '../../actions/musica/player-shared-action-creators';

import MusicUtils from '../../actions/musica/music-actions';
import PlayerAudioSubtitleHelper from './../../AAFPlayer/helpers/PlayerAudioSubtitleHelper';
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import { deviceAttach } from '../../requests/loader';

import Spinner from '../../components/Spinner';

import CoverFlow from '../Epg/CoverFlow';
import EpgLogic from '../Epg/EpgLogic';

import AAF from '../../AAF/AAF';
import {
    RibbonsObserver,
    FirstTimeShowModalPinObserver,
    AlreadyPlayChannelObserver,
} from '../PersistentMiniEpg/MiniObserver';
import LoadingIptvOttFlow from '../../AAF/LoaderExp/LoadingIptvOttFlow';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import asyncPinObserver from '../../AAF/Pin/AsyncPinObserver';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import EventEmitter from '../../utils/EventEmitter';
import AudioTracker from '../../utils/trackers/AudioTracker';
import SetLangsLive from '../../components/EventOptions/components/SetLangsLive';
import { ERROR_CODE_DEVICES_EXCEEDED } from '../../components/Modal/ModalDevicesExceeded';

import {
    LIVE_PLAY_FROM_EPG,
    LIVE_PLAY_FROM_HOME,
    LIVE_PLAY_FROM_MOSAIC,
} from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import { EPGUtil } from '../../AAF/Nepg/EPGUtil';
import {modalInactivityStartLIVESeries, modalInactivityStartVODSeries, modalInactivityPlayVODSeries, handleRedirectModalInactivity} from 'src/components/Modal/functions/ModalInactivity/index';
import PlayerControlsLogic from 'src/playerDomain/components/PlayerControlsLogic';
import UtilsSearch from '../../containers/Search/UtilsSearch';
import NewRelic from '../../utils/trackers/NewRelic';
import { MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER } from '../Modal/ModalPinCode';

const TYPE_OF_REPRODUCTION = 'content_is_vod';

/* Control subtitles */
const subs_in_end_player = 'in-end-player';
const subs_in_controls = 'in-controls';

class Video extends EpgLogic {
    constructor(props) {
        super(props);

        //is playing state to replace router with player, maybe a props.state
        this.playeIsOnScreen = true;
        this.changingChannel = false;

        this.forceStop = false;
        this.record = this.record.bind(this);
        this.onEnded = this.onEnded.bind(this);
        this.handleEpgVisibility = this.handleEpgVisibility.bind(this);
        this.handleNetworkDisconnection = this.handleNetworkDisconnection.bind(this);
        this.replayFromNetworkDisconnect = this.replayFromNetworkDisconnect.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.streamIsVideo = this.streamIsVideo.bind(this);
        this.streamIsAudio = this.streamIsAudio.bind(this);

        this.keyPressHandler = this.keyPressHandler.bind(this);

        this.setAudioTrack = this.setAudioTrack.bind(this);
        this.changeChannel = this.changeChannel.bind(this);
        this.showEPG = this.showEPG.bind(this);
        this.resolveAudioSubtitleFromReplace = this.resolveAudioSubtitleFromReplace.bind(this);
        this.resolveAudioSubtitleFromStart = this.resolveAudioSubtitleFromStart.bind(this);
        this.enableColorActions = this.enableColorActions.bind(this);

        this.playWhenStopMiniEpg = this.playWhenStopMiniEpg.bind(this);
        this.intervalPlayMiniEpg = this.intervalPlayMiniEpg.bind(this);
        this.changeCurrentGroupId = this.changeCurrentGroupId.bind(this);
        this.hideOnlyMini = this.hideOnlyMini.bind(this);
        this.setFromProps = this.setFromProps.bind(this);
        this.getCurrentStreamContentType = this.getCurrentStreamContentType.bind(this);
        this.getCurrentEvent = this.getCurrentEvent.bind(this);
        this.setupTrackerManagerAttached = this.setupTrackerManagerAttached.bind(this);
        this.resetSubtitlesParser = this.resetSubtitlesParser.bind(this);
        this.modalEndPlayer = this.modalEndPlayer.bind(this);
        this.modalEndPlayerCatchup = this.modalEndPlayerCatchup.bind(this);

        this.stopPlayer = this.stopPlayer.bind(this);
        this.getCurrentPlayerOptions = this.getCurrentPlayerOptions.bind(this);

        this.channelInfo = {};
        this.timeshiftEventInfo = {};

        this.state = {
            loading: false,
            fullscreen: false,
            extraClass: '',
            showEpg: false,
            epgGroupId: TvChannelUtil.getLastChannel(),
            timeshiftAllowed: ChannelSingleton.getTimeshift(TvChannelUtil.getLastChannel(), true),
            currentTimeshiftTime: 0,
            subtitleparser: {
                subtitle: null,
                className: null,
            },
            enableplayercontrols: true,
            channelInfo: this.channelInfo,
            epgType: 'GUIDE',
            hasEpgError: false,
            handleChangeSubtitle: null,
            coverFlow: false,
            receiveOK: false,
            filterEpg: null,
            androidIsPlaying: false,
            trackInfo: null,
        };

        this.isPlayerFull = true;
        this.serieData = null;
        this.loaded = false;
        this.keys = Device.getDevice().getKeys();
        this.langOptions = null;
        this.multipleLangOptions = null;
        this.localCurrentTime = 0;
        this.currentLanguageOptionID = null;
        this.currentLanguageOptionIDSubtitle = null;
        this.currentStreamType = null;
        this.playerStreamingUtils = new PlayerStreamingUtils();
        this.guideParams = null;
        this.channelJSON = [];
        this.channelJSONPurchased = [];
        this.linealChannels = this.props.linealChannels;
        this.esteCanal = 0;
        // Guarda el estado actual del player para usarse en caso de networkDisconnect
        this.firstTimeCB = true;
        // AAFPlayer Params, binds, variables, y demás
        // Guardar los params que resolvió AAFPlayer cuando resolvió el streaming a playear
        this.timeShift = null;
        this.isInReplayingFromNetworkDisconnect = false;
        this.AAFResolvedParams = null;
        this.AAFResolvedParamsPip = null;
        this.player = AAFPlayer;
        this.videoCanPlay = false;
        this.deviceAttachAlreadyResponsed = false;

        this.platform = Device.getDevice().getPlatform();
        this.onPlayerControlPause = this.onPlayerControlPause.bind(this);
        this.onPlayerControlPlay = this.onPlayerControlPlay.bind(this);
        this.onPlayerControlResume = this.onPlayerControlResume.bind(this);
        this.onPlayerControlStop = this.onPlayerControlStop.bind(this);
        this.onPlayerControlSeek = this.onPlayerControlSeek.bind(this);
        this.onPlayerSetAudioTrack = this.onPlayerSetAudioTrack.bind(this);
        this.onPlayerEndPlayer = this.onPlayerEndPlayer.bind(this);
        this.onPlayerStopMedia = this.onPlayerStopMedia.bind(this);
        this.doTimeshift = this.doTimeshift.bind(this);
        this.doStartOver = this.doStartOver.bind(this);
        this.performTimeShift = this.performTimeShift.bind(this);
        this.onPlayerError = this.onPlayerError.bind(this);
        this.onCanPlay = this.onCanPlay.bind(this);
        this.onBufferStart = this.onBufferStart.bind(this);
        this.onBufferEnd = this.onBufferEnd.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.updateDurationTime = this.updateDurationTime.bind(this);
        this.onFinishSong = this.onFinishSong.bind(this);
        this.onPlaying = this.onPlaying.bind(this);
        this.onPlayingSong = this.onPlayingSong.bind(this);
        this.onPlayingRadio = this.onPlayingRadio.bind(this);
        this.handleEpg = this.handleEpg.bind(this);
        this.hideEpgOutside = this.hideEpgOutside.bind(this);
        this.onChangingChannel = this.onChangingChannel.bind(this);
        this.isChangingChannel = this.isChangingChannel.bind(this);
        this.getEpgType = this.getEpgType.bind(this);
        this.setEpgType = this.setEpgType.bind(this);
        this.hasEpgError = this.hasEpgError.bind(this);
        this.setEpgError = this.setEpgError.bind(this);
        this.goBack = this.goBack.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.changeLang = this.changeLang.bind(this);
        this.onUpdateEpg = this.onUpdateEpg.bind(this);
        this.controlBarIsShowed = this.controlBarIsShowed.bind(this);
        this.getCurrentTime = this.getCurrentTime.bind(this);
        this.handleSubtitlesEndPlayer = this.handleSubtitlesEndPlayer.bind(this);
        this.onUpdateLangOptions = this.onUpdateLangOptions.bind(this);
        this.onUpdateSprite = this.onUpdateSprite.bind(this);
        this.setSelectedLanguage = this.setSelectedLanguage.bind(this);
        this.setSelectedLanguageLive = this.setSelectedLanguageLive.bind(this);
        this.setNagraLiveLang = this.setNagraLiveLang.bind(this);
        this.onUpdateCurrentTimeshift = this.onUpdateCurrentTimeshift.bind(this);
        this.tryReplay = this.tryReplay.bind(this);
        this.onBookMark = this.onBookMark.bind(this);
        this.onBitrateChange = this.onBitrateChange.bind(this);
        this.ontrackInfo = this.ontrackInfo.bind(this);
        this.playNextEpisodeWhenEndPlayerClosed = this.playNextEpisodeWhenEndPlayerClosed.bind(this);

        // Evento "papá"/main event que envía AAFPlaying, si ya esta todo listo para playear, aquí se recibe lo que se va a playear y desde aquí mismo se envía "play" al media content
        this.onResolveParams = this.onResolveParams.bind(this);
        this.onResolveResizePlayer = this.onResolveResizePlayer.bind(this);
        // Este evento es para cachar errores (generales) de pgm principalmente, o cualquier error que suceda al resolver el playing
        // Ojo, no es para cachar errores del player
        this.onResolveError = this.onResolveError.bind(this);
        // Este callback es para mostrar modales
        this.onResolveShowModal = this.onResolveShowModal.bind(this);
        this.onResolveAsyncPinFailed = this.onResolveAsyncPinFailed.bind(this);
        // Bind para manejo de algunos errores y modales desde AAFPlayer
        this.handleModalReintentoError = this.handleModalReintentoError.bind(this);
        this.handleModalDevicesExceeded = this.handleModalDevicesExceeded.bind(this);
        this.handleModalBookmark = this.handleModalBookmark.bind(this);
        this.handleModalParental = this.handleModalParental.bind(this);
        this.handleCantPlay = this.handleCantPlay.bind(this);

        this.getAAFCallbacks = this.getAAFCallbacks.bind(this);
        this.getAAFPlayerWrapper = this.getAAFPlayerWrapper.bind(this);

        this.getDuration = this.getDuration.bind(this);

        this.afterGetDataSe = this.afterGetDataSe.bind(this);

        this.changeContentfromSelector = this.changeContentfromSelector.bind(this);
        this.goToCard = this.goToCard.bind(this);
        this.getDeviceAttach = this.getDeviceAttach.bind(this);
        this.deviceAttachInTrackerManager = this.deviceAttachInTrackerManager.bind(this);
        this.setTimeshiftSeek = this.setTimeshiftSeek.bind(this);

        this.useChannelRatingFlow = this.useChannelRatingFlow.bind(this);
        this.getChannelInfo = this.getChannelInfo.bind(this);

        this.onTimeshiftEvent = this.onTimeshiftEvent.bind(this);
        this.onFireTPA = this.onFireTPA.bind(this);
        this.onResultFireTPA = this.onResultFireTPA.bind(this);
        this.onSkipToLive = this.onSkipToLive.bind(this);
        this.handleAsyncPinObserver = this.handleAsyncPinObserver.bind(this);
        this.onSeekStartOver = this.onSeekStartOver.bind(this);
        this.onRateChange = this.onRateChange.bind(this);
        this.handleTrackTick = this.handleTrackTick.bind(this);
        this.handleTickOnPause = this.handleTickOnPause.bind(this);
        this.stopTickOnPause = this.stopTickOnPause.bind(this);
        this.useNewPlayerControls = this.useNewPlayerControls.bind(this);
        this._showPlayerEventRecordingNotAvailableNotification =
            this._showPlayerEventRecordingNotAvailableNotification.bind(this);

        // CoverFlow
        this.handleEpgCover = this.handleEpgCover.bind(this);
        this.channelsPurchased = [];
        this.isKeysBloqued = false;
        this.pressTimer = null;
        this.lastKey = null;
        this.delayKeyTime = 50;
        this.keyActionsEnabled = true;
        this.channelControlsEnabled = true;
        this.delayHideCoverFlowTime = 4000;
        this.current = {
            channel: {},
        };
        this.delayCoverFlow = this.delayCoverFlow.bind(this);

        this.lastUpdate = 0;
        document.removeEventListener(
            settings.event_change_network_status,
            this.handleNetworkDisconnection
        );
        document.addEventListener(
            settings.event_change_network_status,
            this.handleNetworkDisconnection
        );
        this.AllEpgs = true;

        this.checkBlockedChannels = this.checkBlockedChannels.bind(this);
        this.setBlockedChannelsListener = this.setBlockedChannelsListener.bind(this);
        this.setBlockedChannelsListener();

        this.alreadyEnterLivePin = [];
        this.goToLive = this.goToLive.bind(this);
        this.sendTPAMetric = this.sendTPAMetric.bind(this);

        asyncPinObserver.subscribe(this.handleAsyncPinObserver);

        this.checkVideo = this.checkVideo.bind(this);
        FallbackUtil.setCallbackFallback(this.checkVideo);

        /**
         * Por el momento sólo android usa su propio interval
         */
        this.trackTickIntervalID = null;
        // En segundos, default tracktick
        this.trackTickIntervalDefaultSeconds = 60;
        /**
         * Con ref de otra forma tarda el render de la watermark del player
         */
        this.refPlayerWatermark = null;
        this.responseDeviceAttachResult = null;
        this.responseDeviceAttachResultWhenError = null;
        this.isFirstTimeShowModalPin = false;
        this.alreadyPlayChannel = false;
        ModalEpgUtils.setHideEpgOutside(this.hideEpgOutside);

        this.nextContentStreamType = null;

        this.eventFullEpg = null;

        /**
         * Tick on pause
         */
        this.tickOnPauseIntervalId = null;
        this.isTPA = null;
        this.tpaData = {};
        this.episodeCount = store.getState().modalInactivity.episodesCount || 0;

        this.nextEpisodeToPlay = null;
        this.PBIEpisodeNext = null;
        this.deviceId = Utils.getDeviceID();
    }

    _showPlayerEventRecordingNotAvailableNotification() {
        store.dispatch(showPlayerEventRecordingNotAvailableNotification());
    }
    /**
     *
     * @param {*} who player_starts = player inicia reproducción
     * esta notificación llega únicamente cuando es player android / STB
     *
     * Esta notificación NO llega desde smartTvs
     */
    handleAsyncPinObserver(who) {
        if (!this.isPlayerFull) return;
        if (who === 'player_starts') {
            if (LoadingIptvOttFlow.isToogleLevelsDelay()) {
                setTimeout(() => RibbonsObserver.fire(true), LoadingIptvOttFlow.delayLevels());
            }
            console.log('[TICK************************] INICIA TRACKING *****************');
            if (
                AAF.Timeshift.playerWatermarkEnabled() &&
                this.refPlayerWatermark &&
                this.AAFResolvedParams &&
                this.AAFResolvedParams.streamContentType
            ) {
                let domD = ReactDOM.findDOMNode(this.refPlayerWatermark);
                const dataPlayerWatermark = AAF.Timeshift.getPlayerWatermarkData(
                    this.AAFResolvedParams.streamContentType
                );
                console.log(
                    '[TICK************************] INICIA TRACKING *****************',
                    this.AAFResolvedParams.streamContentType
                );
                if (dataPlayerWatermark && domD) {
                    domD.style.visibility = 'visible';
                    domD.style.top = dataPlayerWatermark.position.x + 'px';
                    domD.style.left = dataPlayerWatermark.position.y + 'px';
                    domD.style.width = dataPlayerWatermark.size.width + 'px';
                    domD.style.height = dataPlayerWatermark.size.height + 'px';
                    domD.firstChild.src = dataPlayerWatermark.image;
                    domD.style.position = 'relative';
                    domD.firstChild.src = dataPlayerWatermark.image;
                }
            }

            this.handleTrackTick(true);

            if (this.AAFResolvedParams.isLive) {
                console.log(
                    '++++++++ [TICK************************] INICIA TRACKING *****************',
                    this.AAFResolvedParams.streamContentType
                );
                this.setState({ androidIsPlaying: true });
                this.clearLoading();
            }
        }
        if (who === 'player_stop') {
            if (LoadingIptvOttFlow.isToogleLevelsDelay()) {
                setTimeout(() => RibbonsObserver.fire(true), LoadingIptvOttFlow.delayLevels());
            }
            this.handleTrackTick(false);
            if (AAF.Timeshift.playerWatermarkEnabled() && this.refPlayerWatermark) {
                let domD = ReactDOM.findDOMNode(this.refPlayerWatermark);
                if (domD) {
                    domD.style.visibility = 'hidden';
                }
            }
            SetLangsLive.set([]);
        }
        if (who === 'channel_is_blocked') {
            RibbonsObserver.fire(true);
        }
    }

    isAndroidPlatform() {
        return (
            this.platform === playerConstant.ANDROID_PLATFORM ||
            this.platform === playerConstant.ANDROIDTV_PLATFORM
        );
    }

    /**
     * Por el momento sólo android maneja este evento (por el asyncpinobserver que ya está probado que funciona ok en los android players)
     * @param {*} fire boolean fire or stop interval
     */
    handleTrackTick(fire) {
        // Sólo android
        if (!this.isAndroidPlatform()) return;

        if (fire) {
            // Si ya está corriendo el interval, nada que hacer
            if (this.trackTickIntervalID !== null) return;

            let interv = PlayerTracker.policies.tickInterval;
            const { AAFResolvedParams: { streamContentType = null } = {} } = this;
            if (streamContentType && streamContentType === AAF_CONTENT_IS_AUDIO) {
                interv = AudioTracker.policies.tickInterval;

                // Inicia interval para medir tiempo real de reproducción

                TrackerManager.startTimePlaying();
            }
            if (isNaN(interv)) {
                interv = this.trackTickIntervalDefaultSeconds;
            }
            interv = interv * 1000; // seconds to ms
            this.trackTickIntervalID = setInterval(() => {
                console.log(
                    '[TICK************************] send this.localCurrentTime: ' +
                        this.localCurrentTime
                );
                let timecode = this.localCurrentTime;
                if (this.localCurrentTime <= 0) {
                    timecode = 1;
                }
                TrackerManager.tick(timecode);
            }, interv);
        } else {
            if (this.trackTickIntervalID) {
                clearInterval(this.trackTickIntervalID);
                this.trackTickIntervalID = null;
            }
        }
    }

    goToLive() {
        if (this.AAFResolvedParams && this.AAFResolvedParams.groupId) {
            NewRelic.actionText('goToLive', {groupId: this.AAFResolvedParams.groupId})
            this.onSkipToLive(this.AAFResolvedParams.groupId, {
                group_id: this.AAFResolvedParams.groupId,
            });
        }
    }

    /**
     * Registra el listener para escuchar sobre el update/interval de blocked channels
     */
    setBlockedChannelsListener() {
        if (this.useChannelRatingFlow() && !AAF.Pin.usePinRequest()) {
            console.log('[AAF BLOCKED CHANNELS] Video/index setBlockedChannelsListener');
            AAF.Pin.registerBlockedChannelsListener(this.checkBlockedChannels);
        }
    }

    getSpriteImage = () => {
        let spriteImage = null;
        let playerState = AAFPlayer.getCurrentPlayingState(false);
        if (playerState === AAFPLAYER_PLAY) {
            let playerOptions = AAFPlayer.getDevicePlayerParams(false);
            if (
                playerOptions &&
                playerOptions.currentContentType &&
                playerOptions.currentContentType === AAF_CONTENT_IS_VOD
            ) {
                spriteImage =
                    playerOptions.playerMedia &&
                    playerOptions.playerMedia.group &&
                    playerOptions.playerMedia.group.common &&
                    playerOptions.playerMedia.group.common.image_sprites
                        ? playerOptions.playerMedia &&
                          playerOptions.playerMedia.group &&
                          playerOptions.playerMedia.group.common &&
                          playerOptions.playerMedia.group.common.image_sprites
                        : null;
            }
        }
        return spriteImage;
    };
    /**
     *
     * @param {*} updatedBlockedChannels
     */
    checkBlockedChannels(updatedBlockedChannels) {
        console.log(
            '[AAF BLOCKED CHANNELS] Enter Video/index checkBlockedChannels ' +
                JSON.stringify(updatedBlockedChannels)
        );
        // Verificar si se esta usando channel rating flow (incluye android stb kaon y huawei solamente)
        // y si no estamos llamando el pin a cada cambio de canal
        if (this.useChannelRatingFlow() && !AAF.Pin.usePinRequest()) {
            //console.log('[AAF BLOCKED CHANNELS] Video/index checkBlockedChannels, use rating flow');
            // Playing? live?
            let playerState = AAFPlayer.getCurrentPlayingState(false);
            if (playerState === AAFPLAYER_PLAY) {
                let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
                if (
                    playerOptions.source &&
                    playerOptions.source.videoid &&
                    playerOptions.islive &&
                    AAFPlayer.isPlayerPlaying()
                ) {
                    // Es cana bloqueado?
                    // Si ya metió el pin en este mismo canal en el timeout anterior, ya no lo vuelve a pedir
                    let alreadyEnterLivePin = false;
                    if (
                        this.alreadyEnterLivePin.length > 0 &&
                        this.alreadyEnterLivePin.indexOf(playerOptions.source.videoid) >= 0
                    ) {
                        alreadyEnterLivePin = true;
                    }

                    if (
                        updatedBlockedChannels &&
                        updatedBlockedChannels.length > 0 &&
                        updatedBlockedChannels.indexOf(playerOptions.source.videoid) >= 0 &&
                        !alreadyEnterLivePin
                    ) {
                        /**
                         * En este caso ya se sabe que el canal esta bloqueado:
                         *  - Si está en full, el comportamiento es que pida pin y demás
                         *  - Si está en pip, se cerramos el pip, stop player
                         */

                        // FIXME Verificar si esta playeando, si no, el check será hasta el siguiente statuscontrolpin request (i.e. wait for fallback)
                        console.log(
                            '[AAF BLOCKED CHANNELS] Video/index checkBlockedChannels, SI es bloqueado'
                        );
                        if (!AAFPlayer.livePlayingAsPip()) {
                            console.log(
                                '[AAF BLOCKED CHANNELS] Video/index checkBlockedChannels, SI es bloqueado esta en FULL'
                            );
                            // Show pin modal
                            AAFPlayer.pause();
                            const modalData = {
                                modalType: MODAL_PIN,
                                successCallBack: () => {
                                    console.log(
                                        '[AAF BLOCKED CHANNELS] Video/index user success en el pin'
                                    );
                                    this.alreadyEnterLivePin.push(playerOptions.source.videoid);
                                    AAFPlayer.resume();
                                },
                                //useAsyncPin: true,
                                failedCallBack: () => {
                                    console.log(
                                        '[AAF BLOCKED CHANNELS] Video/index falló user en el pin'
                                    );
                                    this.alreadyEnterLivePin = [];
                                    this.onResolveAsyncPinFailed(playerOptions);
                                },
                            };
                            this.onResolveShowModal(modalData);
                        }
                        // Si esta en pip, stop pip
                        else {
                            console.log(
                                '[AAF BLOCKED CHANNELS] Video/index checkBlockedChannels, SI es bloqueado pero esta en PIP'
                            );
                            this.alreadyEnterLivePin = [];
                            store.dispatch(
                                playFullMedia({
                                    //dispatch para actualizar el estado del player en el fin player
                                    ispip: false,
                                    islive: true,
                                    src: null,
                                    playerstate: AAFPLAYER_STOP,
                                    event: null,
                                })
                            );
                        }
                    } else {
                        console.log(
                            '[AAF BLOCKED CHANNELS] TERMINA*** Video/index checkBlockedChannels, NO es bloqueado'
                        );
                    }
                }
            } else {
                console.log(
                    '[AAF BLOCKED CHANNELS] TERMINA*** listener de pin pero no esta playeando'
                );
            }
        }
    }

    getChannelInfo(gid) {
        NewRelic.actionText('getChannelInfo')
        return Utils.getChannelInfo(gid);
    }

    useChannelRatingFlow() {
        return AAF.Pin.useChannelRatingFlow();
    }

    isCriticalChannelById(group_id) {
        return AAF.Pin.isCriticalChannelById(group_id);
    }

    componentWillUpdate(nextProps) {
        if (this.isPropsChange(nextProps.resume, this.props.resume)) {
            this.resetValues();
        }
    }

    resetValues() {
        this.serieData = null;
    }

    isPropsChange(nextProps, props) {
        return nextProps !== props;
    }

    closeModal() {
        store.dispatch(
            showModal({
                modalType: HIDE_MODAL,
                modalProps: {},
            })
        );
    }

    async replayFromNetworkDisconnect() {
        if (this.isInReplayingFromNetworkDisconnect) {
            console.log(
                '[REPLAY FROM NETWORK DISCONNECTED] NetworkStatus se llama a replayFromNetworkDisconnect pero ya se llamó anteriormente'
            );
            //ya esta haciendo el replay? wait...en lo que el player intenta conectarse y playear de nuez
            return;
        }

        let isPip = true;
        let in_stop = AAFPLAYER_STOP;
        let in_play = AAFPLAYER_PLAY;
        let full_state = AAFPlayer.getCurrentPlayingState(!isPip);

        // Cerrar modal, solo aplica a full
        if (!this.AAFResolvedParams.isPip && full_state === in_play) {
            this.closeModal();
            this.isInReplayingFromNetworkDisconnect = true;
            console.log(
                '[REPLAY FROM NETWORK DISCONNECTED] NetworkStatus se llama a replayFromNetworkDisconnect para intentar reproducir de nuez'
            );
            let isVOD = !this.AAFResolvedParams.isLive;

            // Las ultimas opciones con que se fue al playing...
            let latestVideoOptions = AAFPlayer.getCurrentPlayerOptions();
            // Si es video
            if (this.streamIsVideo(this.AAFResolvedParams.streamType)) {
                // Trackstop en full (& bookmark ¿? stop genera bookmark o forzó a resume en el currentTime en que se quedó????) antes de replay
                if (isVOD) {
                    // TODO meter tracking stop aquí
                }
                latestVideoOptions.resume = this.localCurrentTime;
                // Hay langs? los enviamos para ahorrar una llamada a content/data
                if (Utils.isArray(this.AAFResolvedParams.extendedCommonLangOptions)) {
                    latestVideoOptions.languageoptions =
                        this.AAFResolvedParams.extendedCommonLangOptions;
                }
                // Primero stop / para forzar el replay del MISMO contenido
                AAFPlayer.setPlayerState({ playerstate: in_stop, ispip: false });
                // Meter un timeout antes de enviar a play de nuevo¿?
                AAFPlayer.setPlayerState(latestVideoOptions);
            }
            // TODO Si es audio ¿? Validar con música, cómo generar nuevo token¿?
            if (this.streamIsAudio(this.AAFResolvedParams.streamType)) {
                // Primero stop / para forzar el replay del MISMO contenido
                AAFPlayer.setPlayerState({ playerstate: in_stop, ispip: false });
                // Meter un timeout antes de enviar a play de nuevo¿?
                AAFPlayer.setPlayerState(latestVideoOptions);
            }
        }
        // TODO replay SPOT ¿?
    }

    async handleNetworkDisconnection(evt) {
        // Si no hay current state de playing, nada que hacer, y si, pasa por aquí dos veces :S
        if (this.AAFResolvedParams === null && this.AAFResolvedParamsPip === null) {
            console.log(
                '[REPLAY FROM NETWORK DISCONNECTED] 1 NetworkStatus recibe evento de red, esta conectado pero seguramente el user le dió clic a reintentar'
            );
            return;
        }
        // Si no esta en player, nada que hacer, deja pasar el evento de desconexión
        let isPip = true;
        let in_stop = AAFPLAYER_STOP;
        let in_play = AAFPLAYER_PLAY;
        let pip_state = AAFPlayer.getCurrentPlayingState(isPip);
        let full_state = AAFPlayer.getCurrentPlayingState(!isPip);

        if (pip_state === in_stop && full_state === in_stop) {
            return;
        }
        // Si es pip y esta por DVBC nada que hacer, va por cable
        if (pip_state === in_play) {
            if (
                this.AAFResolvedParams.streamType === playerConstant.DVBC ||
                this.AAFResolvedParams.streamType === playerConstant.DVBS
            ) {
                return;
            }
        }
        if (full_state === in_play) {
            if (
                this.AAFResolvedParams.streamType === playerConstant.DVBC ||
                this.AAFResolvedParams.streamType === playerConstant.DVBS
            ) {
                return;
            }
        }
        // pip sobre internet, destroy & kill <- TODO
        if (pip_state === in_play) {
            AAFPlayer.setPlayerState({ playerstate: in_stop, ispip: true });
        }

        // Abajo todo sobre player full
        // Se restaura network
        if (evt.detail) {
            if (this.isInReplayingFromNetworkDisconnect) {
                //ya esta haciendo el replay?
                return;
            }
            this.replayFromNetworkDisconnect();
        }
        // No hay red, player stop ¿?
        else {
            if (this.streamIsVideo(this.AAFResolvedParams.streamType)) {
                console.log('[REPLAY FROM NETWORK DISCONNECTED] NetworkStatus manda a pausa');
                this.player.pause();
                this.isInReplayingFromNetworkDisconnect = false;
                // Lanzar modal
                const defaultTile = 'Tienes un problema con tu conexión';
                const defaultContent =
                    'Revisa que tu servicio de Internet esté funcionando de forma correcta e intenta nuevamente.';

                // Youbora
                if (window.youboraTrackingPlugin) {
                    if (
                        window.youboraTrackingPlugin.getAdapter &&
                        typeof window.youboraTrackingPlugin.getAdapter === 'function'
                    ) {
                        const youboraAdapter = window.youboraTrackingPlugin.getAdapter();
                        if (
                            youboraAdapter.fireError &&
                            typeof youboraAdapter.fireError === 'function'
                        ) {
                            youboraAdapter.fireError('Problema de conexión');
                            if (
                                youboraAdapter.fireStop &&
                                typeof youboraAdapter.fireStop === 'function'
                            ) {
                                youboraAdapter.fireStop();
                            }
                        }
                    }
                }

                const p = {
                    title: Translator.get('network_error_ConnectException_title', defaultTile),
                    content: Translator.get('network_error_ConnectException_msg', defaultContent),
                    buttons: [
                        {
                            content: Translator.get('btn_modal_retry', 'Reintentar'),
                            props: {
                                onClick: (e) => {
                                    console.log(
                                        '[REPLAY FROM NETWORK DISCONNECTED] NetworkStatus n modal clic en reintentar checando si hay red...'
                                    );
                                    new DeviceNetworkStatus().isOnline().then((isOnline) => {
                                        if (isOnline) {
                                            console.log(
                                                '[REPLAY FROM NETWORK DISCONNECTED] NetworkStatus en modal clic en reintentar SI hay red'
                                            );
                                            this.replayFromNetworkDisconnect();
                                        } else {
                                            console.log(
                                                '[REPLAY FROM NETWORK DISCONNECTED] NetworkStatus en modal clic en reintentar NO hay red'
                                            );
                                        }
                                    });
                                },
                            },
                        },
                        {
                            content: Translator.get('btn_modal_ok', 'Aceptar'),
                            props: {
                                onClick: (e) => {
                                    this.closeModal();
                                },
                            },
                        },
                    ],
                };
                AAFPlayer.setTryingToPlayOptions(null);
                store.dispatch(
                    showModal({
                        modalType: MODAL_DESCONEXION,
                        modalProps: p,
                    })
                );

                if (!this.AAFResolvedParams.isLive) {
                    if (isNaN(this.localCurrentTime)) {
                        this.localCurrentTime = 0;
                    }
                    // Guardar tiempo de reproducción en VOD, para después hacer el resume
                    this.localCurrentTime = Math.floor(this.localCurrentTime);
                }
            }
        }
    }

    // TODO AAFPlayer, pasar esta lógica a AAPlayer
    changeLang(data, callbackAction) {
        console.log('[MA-LIVE]-entrando en el cambio de audio');
        // For test
        //this.handleSubtitlesParser('https://l3edvwdclmxp01.secure.footprint.net/B18386206HD_11EWVMD10C/B18386206HD_11EWVMD10C_spa.webvtt');
        console.log('[Video component] enter changeLang: ', data);
        NewRelic.addPageAction('change-lang', {data});

        // HARDCODED Only for nagra live DVBC, data.id_lang only present when get audiotracks from live/dvbc
        if (
            this.isPlayerFull &&
            this.platform === 'nagra' &&
            data.id_lang &&
            this.props.player.isLive
        ) {
            this.setAudioTrack(data.id_lang);

            return;
        }

        // Language change only in full
        if (this.isPlayerFull) {
            console.log('[Video component] current FULL props: ', this.props.player);

            if (
                this.AAFResolvedParams.currentContentType === AAF_CONTENT_IS_TV ||
                this.AAFResolvedParams.currentContentType === AAF_CONTENT_IS_STARTOVER ||
                this.AAFResolvedParams.currentContentType === AAF_CONTENT_IS_CATCHUP ||
                this.AAFResolvedParams.currentContentType === AAF_CONTENT_IS_NPVR
            ) {
                console.log('[MA-LIVE]-data=', data);
                console.log('[MA-LIVE]-this.currentLanguageOptionID=' + data.option_id);
                console.log(
                    '[MA-LIVE]-this.AAFResolvedParams.currentContentType=' +
                        this.AAFResolvedParams.currentContentType
                );
                console.log('[MA-LIVE]-data-track=' + data.track);
                if (data && data.isAudio) {
                    if (data.track === this.currentLanguageOptionID) {
                        return;
                    }
                    this.setAudioTrackLive(data.track, this.currentLanguageOptionIDSubtitle);
                    this.setSelectedLanguageLive(data.track, true);
                } else {
                    if (data.track === this.currentLanguageOptionIDSubtitle) {
                        return;
                    }
                    this.setAudioTrackLive(this.currentLanguageOptionID, data.track);
                    this.setSelectedLanguageLive(data.track, false);
                }
                return;
            }

            // Only VOD for all devices
            if (!this.AAFResolvedParams.isLive) {
                // Same lang, nothing to do
                if (data.option_id === this.currentLanguageOptionID) {
                    return;
                }
                // Resolve next streamType
                let nextStreamTypeIsMultiple = PlayerAudioSubtitleHelper.ifMultipleStreamExists(
                    this.AAFResolvedParams.currentContentType,
                    data.encodes
                );

                // Current playing is multiple?
                console.log(
                    '[Video component] currentStreamType: ',
                    this.AAFResolvedParams.streamType
                );
                if (
                    this.playerStreamingUtils.isMultipleStreamType(
                        this.AAFResolvedParams.streamType
                    )
                ) {
                    // multiple to multiple (TODO enable or disable parser)
                    if (nextStreamTypeIsMultiple) {
                        // TODO switch to desired multiple...calling setAudioTrack and enable or disable subtitle parser
                        let nextAudio = null;
                        let nextSubtitleURL = null;
                        if (data.audio) {
                            nextAudio = this.playerStreamingUtils.getAudioForSelectedLang(
                                data.audio,
                                this.multipleLangOptions.audio
                            );
                        }
                        if (data.subtitle) {
                            nextSubtitleURL = this.playerStreamingUtils.getSubtitleForSelectedLang(
                                data.subtitle,
                                this.multipleLangOptions.subtitles
                            );
                        }
                        // On parser
                        if (nextSubtitleURL) {
                            console.log('[Video component] Parser ON', nextSubtitleURL);
                            this.handleSubtitlesParser(nextSubtitleURL);
                        }
                        // Off parser
                        else {
                            console.log('[Video component] Parser OFF');
                            this.resetSubtitlesParser();
                        }
                        if (nextAudio && this.platform !== 'workstation') {
                            this.setAudioTrack(nextAudio);
                            this.setSelectedLanguage(data.option_id);
                            callbackAction.play();
                        }
                    }
                    // multiple to single (TODO enable or disable parser)
                    else {
                        callbackAction.resetSeekInPause();
                        this.handleChangeLang(
                            this.AAFResolvedParams.groupId,
                            data,
                            this.AAFResolvedParams.isTrailer,
                            this.AAFResolvedParams.streamType,
                            this.AAFResolvedParams.isLive
                        );
                    }
                }
                // current playing single
                else {
                    callbackAction.resetSeekInPause();
                    // single to multiple (TODO enable or disable parser)
                    if (nextStreamTypeIsMultiple) {
                        this.handleChangeLang(
                            this.AAFResolvedParams.groupId,
                            data,
                            this.AAFResolvedParams.isTrailer,
                            this.AAFResolvedParams.streamType,
                            this.AAFResolvedParams.isLive
                        );
                    }
                    // single to single
                    else {
                        this.handleChangeLang(
                            this.AAFResolvedParams.groupId,
                            data,
                            this.AAFResolvedParams.isTrailer,
                            this.AAFResolvedParams.streamType,
                            this.AAFResolvedParams.isLive
                        );
                    }
                }
            }
        }
    }

    /**
     *
     * @param {*} params los params que resolvío AAFPlayer y que fon enviados al playerz
     * @param groupId
     * @param selectedDataLang
     * @param isTrailer
     * @param streamType
     * @param isLive
     */
    handleChangeLang(groupId, selectedDataLang, isTrailer, streamType, isLive) {
        // Settear el sig lang seleccionado para que AAFPlayer lo encuentre antes de resolver
        this.setSelectedLanguage(selectedDataLang.option_id);
        let resume = this.getCurrentTime();
        if (selectedDataLang.resume) {
            resume = selectedDataLang.resume;
        }

        let poptions = {
            playerstate: 'PLAYING',
            source: {
                //videoid: 764423
                videoid: groupId,
            },
            // Para diferenciar entre cambios de single
            languageoptionid: selectedDataLang.option_id,
            languageoptions: this.AAFResolvedParams.extendedCommonLangOptions,
            ispreview: isTrailer,
            islive: isLive,
            ispip: false,
            // Si llegué aquí entonces es porque practicamente voy a
            // hacer un reemplazo de source en el player, sobreescribo el resume
            // para ignorar el init playback seconds
            resume: resume,
            ischangelang: true,
        };

        if (!isLive) {
            const vodOptions = AAFPlayer.getCurrentPlayerOptions(false);
            const { source: { seasonid = null } = {} } = vodOptions;
            let pr = { groupId };
            if (seasonid) {
                poptions.source.seasonid = seasonid;
                pr.seasonId = seasonid;
            }
            api.PurchaseButtonInfov585(pr)
                .then((resp) => {
                    const { playButton: { payway_token = null } = {} } = resp;
                    poptions.payway_token = payway_token;
                    AAFPlayer.setPlayerState(poptions);
                })
                .catch((err) => {
                    AAFPlayer.setPlayerState(poptions);
                });
        } else {
            AAFPlayer.setPlayerState(poptions);
        }
    }

    setSelectedLanguage(language) {
        console.log('[Video component] setSelectedLanguage:', language);
        DeviceStorage.setItem('default_lang', language);
        this.currentLanguageOptionID = language;
    }

    setSelectedLanguageLive(language, isAudio) {
        if (isAudio) {
            DeviceStorage.setItem('default_lang_audio_live', language);
            this.currentLanguageOptionID = language;
        } else {
            DeviceStorage.setItem('default_lang_subtitle_live', language);
            this.currentLanguageOptionIDSubtitle = language;
        }
    }

    setAudioTrack(codeTrack) {
        console.log('@@@@@@@@ setAudioTrack 3');
        return this.player.setAudioTrack(codeTrack);
    }

    setAudioTrackLive(codeTrack, subtitleTrack) {
        console.log('@@@@@@@@ setAudioTrack 3');
        return this.player.setAudioTrackLive(codeTrack, subtitleTrack);
    }

    showError(
        message,
        callback = () => {
            console.log('Error on player');
        }
    ) {
        const modalProps = {
            callback,
            content: { message },
        };

        store.dispatch(
            showModal({
                modalType: AAF_MODAL_ERROR,
                modalProps: modalProps,
            })
        );
    }

    onPlayerError(errorMessage, errorCode, params, currentTimeSeconds) {
        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: onPlayerError'} ${'Message: ' + errorMessage}`);

        const { streamContentType = null } = params;
        const streamContentTypeIsLive = streamContentType === AAF_CONTENT_IS_TV;
        const isFallbackErrorEnable = FallbackHelper.getFallbackErrorEnable();
        const isFallbackError = FallbackHelper.isFallbackError(errorMessage);
        const { player: { islive } } = this.props;
        this.isInReplayingFromNetworkDisconnect = false;
        /**
         * No importa si es audio o video, reset del tiempo REAL de reproducción de audio
         */

        TrackerManager.resetTimePlaying();
        new DeviceNetworkStatus().isOnline().then((isOnline) => {
            this.isInReplayingFromNetworkDisconnect = false;
            if (isOnline) {
                if (LoadingIptvOttFlow.isToogleLevelsDelay()) {
                    RibbonsObserver.fire(true);
                }
                // Si esta en red quiza sea otro tipo de error
                let messageToDisplay = '';
                if (this.isPlayerFull) {
                    console.log(
                        '[TICK************************] playerError se desactiva el tracktick'
                    );
                    this.handleTrackTick(false);
                    this.onChangingChannel(false);
                    this.stopTickOnPause();
                    this.inPlayerError = true;
                    let stvErrorCode = '';
                    let playerState = this.player.getCurrentPlayerState();
                    if (
                        playerState === PONPLAY ||
                        playerState === PONPAUSE ||
                        playerState === PONSTOP
                    ) {
                        stvErrorCode = '20027';
                    } else if (playerState === PONCONNECT) {
                        stvErrorCode = '20028';
                    } else {
                        stvErrorCode = '3000';
                    }

                    if (!errorCode) {
                        errorCode = playerConstant.onUnknownError;
                    }
                    messageToDisplay =
                        (stvErrorCode !== '' ? stvErrorCode + ' ' : '') +
                        '[' +
                        errorCode +
                        '] ' +
                        errorMessage;
                    const modalProps = {
                        onReject: () => {
                            this.inPlayerError = false;
                            console.log('Modal player Error> ', errorMessage, errorCode);
                        },
                        onRetry: () => this.tryReplay(),
                        skipRetryPlayer: true, // TODO verificar con la gente de youbora
                        messageModal: messageToDisplay,
                        isLive: islive
                    };

                    const paramsTrackersManager = {
                        e: messageToDisplay,
                        currentTime: currentTimeSeconds,
                        streamType: params.streamType,
                        errorCodeYoubora: errorCode || '',
                        errorMessageYoubora: errorMessage || '',
                      }

                      // Se manda el error track
                      TrackerManager.error(paramsTrackersManager);

                      if (params.isLive)
                          TrackerManager.errorLive(paramsTrackersManager);
                      else
                          TrackerManager.errorContent(paramsTrackersManager);

                    // Errores, todo lo que sea live, se manda a modal
                    if (!streamContentTypeIsLive) {
                        store.dispatch(
                            showModal({
                                modalType: MODAL_REINTENTO,
                                modalProps: modalProps,
                            })
                        );
                    }
                    // Si es live, se  verifica por las llaves
                    else {
                        if (isFallbackErrorEnable || isFallbackError) {
                            // Opción 2
                            FallbackUtil.setError(errorMessage);
                            TrackerManager.fallbackError(params.streamType, errorMessage, params.src);
                            FallbackUtil.clearFallback();
                            // ESTE ES EL FALLBACK
                            NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: onPlayerError'} ${'Message: Error conocido apk 503'}`);
                            this.checkVideo(
                                FallbackUtil.getOutputParams() ? FallbackUtil.getOutputParams() : params
                            );
                        } else {
                            FallbackUtil.setError(null);
                            // Opción 2
                            // No es fallback, se muestra modal de reintento
                            store.dispatch(
                                showModal({
                                    modalType: MODAL_REINTENTO,
                                    modalProps: modalProps,
                                })
                            );
                        }
                    }
                }

            }
            // Si no esta en red el player controla su network disconnect
            else {
                console.log(
                    '[REPLAY FROM NETWORK DISCONNECTED] cayó un playerError pero seguro fue de red, se ajusta arriba'
                );
            }
        });
    }

    tryReplay() {
        FallbackUtil.clearFallback();
        this.inPlayerError = false;
        // Usemos el mismo método para network disconnect
        this.replayFromNetworkDisconnect();
    }

    onBookMark(time) {
        const seekObject = {
            seek_start: time,
        };
        TrackerManager.seek(seekObject);
    }

    onBitrateChange(bitrate, bandwidth, time) {
        console.log('Video onBitrateChange bitrate, bandwidth', bitrate, bandwidth);
        if (bitrate !== 0 && bandwidth !== 0) {
            TrackerManager.bitRateChange(bitrate, bandwidth, time);
        }
    }

    ontrackInfo(trackInfo) {
        if (this.AAFResolvedParams.currentContentType) {
            switch (this.AAFResolvedParams.currentContentType) {
                case AAF_CONTENT_IS_TV:
                case AAF_CONTENT_IS_TIMESHIFT:
                case AAF_CONTENT_IS_STARTOVER:
                case AAF_CONTENT_IS_CATCHUP:
                case AAF_CONTENT_IS_NPVR:
                    SetLangsLive.set(trackInfo);
                    break;
                default:
                    break;
            }
        }

        if (this.refs.playerControls) {
            this.refs.playerControls.setTrackInfo(trackInfo);
        }
    }

    async getContentData(gid) {
        let contentData = await api.contentData(gid);
        return contentData;
    }

    async changeChannel(newChannelIndex, isgid = false, channel, playLiveFrom = null) {
        if (window.performance)
            console.log(
                '[TIMEMARK] entrando changeChannel, se hace el dispatch ' + window.performance.now()
            );
        if (this.isChangingChannel()) {
            return;
        }

        this.firstTimeCB = true;

        let gid = isgid ? newChannelIndex : this.channelJSONPurchased[newChannelIndex];
        //TvChannelUtil.setLastChannel(gid); solo se debe de ejecutar en onResolveParams de components/Video
        NewRelic.addPageAction('change-channel', gid)

        if (window.performance)
            console.log(
                '[TIMEMARK] en medio changeChannel, se hace el dispatch ' + window.performance.now()
            );

        const isSusc = await this.playerStreamingUtils.checkSusc(null, gid,  ()=>{});

        let newChannel = {
            playerstate: 'PLAYING',
            source: {
                videoid: gid,
            },
            // Force full player al cambiar canal
            size: {
                top: 0,
                left: 0,
                width: 1280,
                height: 720,
            },

            ispreview: false,
            islive: true,
            ispip: false,
            cb: () => {
                if (this.refs.playerControls && !isgid) {
                    //this.refs.playerControls.hide();
                    this.firstTimeCB = false;
                }
            },
        };

        /**
         * En este momento esto sólo se usa desde
         * el mosaico EPG:
         * ModalEpgUtils > handleChangeChannel
         */
        if (playLiveFrom) {
            newChannel.playLiveFrom = playLiveFrom;
        }

        //console.log('[AAF Quick] before request AAFPlayerChange', new Date()- window.startTime);

        // Ahorita se mantiene el dispatch, para que AAFPlayer este en sync con props de video component
        // Pero sí considerar revisar alguna forma de mantener en sync props y AAF state en sync para que
        // se puedan hacer cosas como AAFPlayer.setPlayerState directamente y mejorar performance
        if (window.performance)
            console.log(
                '[TIMEMARK] terminando changeChannel, se hace el dispatch ' +
                    window.performance.now()
            );

        if(isSusc) {
            store.dispatch(playFullMedia(newChannel));
        }
        if (channel) {
            this.onSelectCard(channel);
        }
        /*
     if (this.props.player.islive) {
     store.dispatch(playFullMedia(newChannel));
     //AAFPlayer.setPlayerState(newChannel, this.getAAFPlayerWrapper(), this.getAAFCallbacks())
     }
     else {
     store.dispatch(playFullMedia(newChannel));
     }
     */
    }

    changeContentfromSelector(groupId, paywayToken = "") {
        // Mandar trackstop/track episode change
        TrackerManager.episodeChange(this.getCurrentTime(), this.AAFResolvedParams.streamType);

        const vodOptions = AAFPlayer.getCurrentPlayerOptions(false);
        const { source: { seasonid = null } = {} } = vodOptions;

        let newChapter = {
            playerstate: 'PLAYING',
            source: {
                videoid: groupId,
            },
            ispreview: false,
            islive: false,
            ispip: false,
            ischangeepisode: true,
            //FLAG para no volver a pedir pin para el flujo selector de episodio desde PC
            skipPin: true,
            payway_token: paywayToken
        };

        if (seasonid) {
            api.PurchaseButtonInfov585({ groupId, seasonId: seasonid })
                .then((resp) => {
                    const { playButton: { payway_token = null } = {} } = resp;
                    newChapter.payway_token = payway_token;
                    newChapter.source.seasonid = seasonid;
                    AAFPlayer.setPlayerState(
                        newChapter,
                        this.getAAFPlayerWrapper(),
                        this.getAAFCallbacks()
                    );
                    if (this.refs.playerControls) {
                        this.refs.playerControls.show();
                    }
                })
                .catch((err) => {
                    AAFPlayer.setPlayerState(
                        newChapter,
                        this.getAAFPlayerWrapper(),
                        this.getAAFCallbacks()
                    );
                    if (this.refs.playerControls) {
                        this.refs.playerControls.show();
                    }
                });
        } else {
            AAFPlayer.setPlayerState(
                newChapter,
                this.getAAFPlayerWrapper(),
                this.getAAFCallbacks()
            );
            if (this.refs.playerControls) {
                this.refs.playerControls.show();
            }
        }
    }

    getChUpChannel() {
        let lastChannel = TvChannelUtil.getLastChannel();
        let lastChannelIndex = lastChannel ? this.channelJSONPurchased.indexOf(lastChannel) : -1;
        let channelIndex = this.esteCanal;
        channelIndex =
            lastChannelIndex !== -1 ? lastChannelIndex : this.esteCanal === -1 ? 0 : this.esteCanal;
        let newChannelIndex =
            channelIndex === this.channelJSONPurchased.length - 1 ? 0 : channelIndex + 1;
        return newChannelIndex;
    }

    getChDownChannel() {
        let lastChannel = TvChannelUtil.getLastChannel();
        let lastChannelIndex = lastChannel ? this.channelJSONPurchased.indexOf(lastChannel) : -1;
        let channelIndex =
            lastChannelIndex !== -1 ? lastChannelIndex : this.esteCanal === -1 ? 0 : this.esteCanal;
        let newChannelIndex =
            channelIndex === 0 ? this.channelJSONPurchased.length - 1 : channelIndex - 1;
        return newChannelIndex;
    }

    changeCurrentGroupId(currentEpg) {
        this.currentEpg = currentEpg;
    }

    intervalPlayMiniEpg() {
        if (this.currentEpg && !Utils.isEmpty(this.currentEpg)) {
            const { channel } = this.currentEpg;
            let gid = channel.group_id;
            this.hideEpgOutside(gid, channel);
        }
    }

    setFromProps(value) {
        this.fromProps = value;
    }

    getCurrentStreamContentType() {
        return AAFPlayer.getCurrentStreamContentType();
    }
    getCurrentEvent = () => {
        return this.eventFullEpg;
    };

    async playWhenStopMiniEpg(key) {
        if (!Utils.isEmpty(this.props.player) && this.props.player.playerstate === AAFPLAYER_PLAY) {
            this.setFromProps(true);
            if (this.props.player.islive && !AAFPlayer.livePlayingAsPip()) {
                if (this.playInMini) {
                    clearTimeout(this.playInMini);
                }
                let timeIntVal = 500; // 500ms por default
                let _timeIntVal = Utils.getDelayByChdownup();
                if (!isNaN(_timeIntVal)) {
                    timeIntVal = _timeIntVal;
                }
                console.log('[INICIOPLAY_DELAY] usando delay de ' + timeIntVal + 'ms');
                this.playInMini = setTimeout(() => {
                    window.INICIOPLAYUPDOWN = window.performance.now();
                    if (window.performance)
                        console.log(
                            '[TIMEMARK] Envío cambio canal con chup/chdown ' +
                                window.performance.now()
                        );

                    this.intervalPlayMiniEpg();
                }, timeIntVal);
            } else {
                switch (key) {
                    case 'CH_UP':
                      if(Utils.modalType() === MODAL_INACTIVITY){
                        e.preventDefault();
                          e.stopPropagation();
                        return;
                      }
                        await this.changeChannel(this.getChUpChannel());
                        break;
                    case 'CH_DOWN':
                      if(Utils.modalType() === MODAL_INACTIVITY){
                        e.preventDefault();
                          e.stopPropagation();
                        return;
                      }
                        await this.changeChannel(this.getChDownChannel());
                        break;
                    default:
                        break;
                }
            }
        }
    }

    clearFallback = () => {
        FallbackUtil.clearFallback();
    };

    keyPressHandler(e) {
        this.episodeCount = 0;
        window.startTime = new Date();
        //console.log('[AAF Quick] press key', new Date()- window.startTime, this.channelJSONPurchased.length);
        if (this.channelJSONPurchased.length === 0) {
            return;
        }

        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (!this.keyActionsEnabled) {
            return false;
        }

        switch (currentKey) {
            case 'CH_UP':
            case 'CH_DOWN':
              if(Utils.modalType() === MODAL_INACTIVITY){
                e.preventDefault();
                  e.stopPropagation();
                return;
              }
                if (this.isChangingChannel()) {
                    return;
                }
                store.dispatch(navigateFrom('Keys'));

                if (!this.AAFResolvedParams) {
                    break;
                }

                if (!this.AAFResolvedParams.isLive) {
                    break;
                }

                FallbackUtil.clearFallback();

                if (
                    Utils.choiceBehaviorChannelChange() &&
                    !Utils.isFullEpgOpen() &&
                    !Utils.isFullEpgMosaicOpen()
                ) {
                    this.playWhenStopMiniEpg(currentKey);
                } else {
                    this.handleDelayKey(e, currentKey);
                }
                break;
            case 'PREV':
                // let utl = 'octoshape://mabr-linear.clarotv.com.ar/amx/live/ehls/ar/sd/encuentro/2100k';
                // window.AndroidPlayerInterface.loadMediaUrl(utl);
                if (window.performance) window.INICIOPLAYBOTONPREV = window.performance.now();

                document.dispatchEvent(
                    new CustomEvent('manage_action_bar', {
                        detail: { visible: false, data: null, event: null },
                    })
                );

                let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
                let act = TvChannelUtil.handlePREV();
                if (playerOptions.islive && act.action === 'channelchange') {
                    FallbackUtil.clearFallback();

                    this.setFromProps(true);
                    store.dispatch(
                        playFullMedia({
                            playerstate: 'PLAYING',
                            source: {
                                videoid: act.gid,
                            },
                            size: {
                                top: 0,
                                left: 0,
                                width: 1280,
                                height: 720,
                            },
                            ispreview: false,
                            islive: true,
                            ispip: false,
                            event: null,
                        })
                    );
                }
                break;
            case 'OK':
                if (Utils.isModalHide()) {
                    FallbackUtil.clearFallback();
                }
                break;
            default:
                break;
        }
    }

    // CoverFlow functions start
    updateEpg(channel, event, focused) {
        if (typeof this.onUpdateEpg == 'function') {
            this.onUpdateEpg(channel.group_id);
        }
    }

    handleEpgCover() {
        this.hideCoverFlow();
        this.handleEpg(true);
    }

    hideCoverFlow() {
        const selector = '.focusable';
        super.hideCoverFlow(selector);
    }

    delayCoverFlow() {
        clearTimeout(this.timerCoverFlow);
        this.timerCoverFlow = setTimeout(() => this.hideCoverFlow(), this.delayHideCoverFlowTime);
    }

    enableColorActions() {
        this.keyActionsEnabled = true;
    }

    disableColorActions() {
        this.keyActionsEnabled = false;
    }

    channelsCoverFLow(data) {
        this.channelsPurchased = data.filter(
            (channel) => this.channelJSONPurchased.indexOf(channel.group_id) > -1
        );
        let groupId =
            this.ResolvegroupId || (this.props.player.source && this.props.player.source.videoid);
        // console.log('[dann] canal de reproduccion actual:,', groupId);
        this.current.channel = {
            group_id: groupId,
        };
        // groupid es el canal actual en reproduccion, se usara este id para comparar todos los datos del current data que se envia a CoverFlow components
    }

    async handleDelayKey(e, key) {
        const pathname = window.location.pathname.split('/');
        if (pathname.indexOf(settings.path_suscription) !== -1) {
            return;
        }

        this.isKeysBloqued = !!(this.lastKey === key && this.pressTimer);
        this.lastKey = key;

        if (this.lastKey !== key && this.pressTimer) {
            clearTimeout(this.pressTimer);
        }
        if (this.isKeysBloqued) {
            if (Utils.getCoverFlowVisibilityFromMetadata().enable) {
                e.stopPropagation();
                e.preventDefault();
                this.launchCoverFlow(true);
            }
            if (this.state.showEpg) this.handleEpg(false);
        } else {
            this.pressTimer = setTimeout(this.resetTimer, this.delayKeyTime);
            if (window.performance) window.INICIOPLAYUPDOWN = window.performance.now();
            switch (key) {
                case 'CH_UP':
                  if(Utils.modalType() === MODAL_INACTIVITY){
                    e.preventDefault();
                      e.stopPropagation();
                    return;
                  }
                    await this.changeChannel(this.getChUpChannel());
                    break;
                case 'CH_DOWN':
                  if(Utils.modalType() === MODAL_INACTIVITY){
                    e.preventDefault();
                      e.stopPropagation();
                    return;
                  }
                    await this.changeChannel(this.getChDownChannel());
                    break;
                default:
                    break;
            }
        }
    }
    // CoverFlow functions finish

    resetSubtitlesParser() {
        //return; //only for test
        let subtitlesParser = {
            subtitle: null,
            className: null,
        };

        this.setState({ subtitleparser: subtitlesParser });
    }

    setCurrentTime(time, timeForSubtitle) {
        if (typeof this.state.handleChangeSubtitle === 'function' && time);
        this.state.handleChangeSubtitle(timeForSubtitle); //esta funcion se setea desde VirtualSubtitles
        this.localCurrentTime = time;
    }

    getCurrentTime() {
        return this.localCurrentTime;
    }

    goToCard(path, extradata) {
        this.props.changePath(path, extradata);
    }

    handleSubtitlesEndPlayer(e) {
        /* groupId={state.groupId}
     title={state.title}
     previewImg={state.previewImg}
     backgroundImg={state.backgroundImg}
     next={state.next}
     recommendations={state.recommendations}
     serieData={state.serieData}*/

        let next = null;
        if (
            this.AAFResolvedParams.playerMedia.next_group &&
            this.AAFResolvedParams.playerMedia.next_group.common
        ) {
            next = this.AAFResolvedParams.playerMedia.next_group.common;
        }

        // TODO validar cuando no haya groupid

        let bg = null;
        if (
            this.AAFResolvedParams.playerMedia.group &&
            this.AAFResolvedParams.playerMedia.group.common &&
            this.AAFResolvedParams.playerMedia.group.common.image_background
        ) {
            bg = this.AAFResolvedParams.playerMedia.group.common.image_background;
        }

        let title = '';
        if (
            this.AAFResolvedParams.playerMedia.group &&
            this.AAFResolvedParams.playerMedia.group.common &&
            this.AAFResolvedParams.playerMedia.group.common.title
        ) {
            title = this.AAFResolvedParams.playerMedia.group.common.title;
        }

        console.log('handleSubtitlesEndPlayer FIN PLAYER');
        if (this.state.subtitleparser.subtitle) {
            let subtitleparser = {
                className: subs_in_end_player,
                subtitle: this.state.subtitleparser.subtitle, // Same subs
            };
            this.setState({ subtitleparser: subtitleparser });
        }
        this.refs.playerControls && this.refs.playerControls.hide();
    }

    controlBarIsShowed(isShowed) {
        document.dispatchEvent(
            new CustomEvent('handlesubtitlesscreenposition', {
                detail: { isShowed: isShowed, className: subs_in_controls },
            })
        );
    }

    async handleSubtitlesParser(url) {
        console.log('[Video component] llegando a handleSubtitlesParser', url);
        let subtitlesParser = {
            subtitle: null,
            className: null,
        };
        // On parser
        try {
            if (url) {
                let provider = null;
                if (this.AAFResolvedParams && this.AAFResolvedParams.provider) {
                    provider = this.AAFResolvedParams.provider;
                }
                let subtitlesTask = new PlayerSubtitlesTask(url, provider);
                let vtt = await RequestManager.addRequest(subtitlesTask);
                subtitlesParser.subtitle = vtt;
                // start subs with playerControls in on
                subtitlesParser.className = '';
            }
        } catch (e) {
            console.log('[Video component] error catch', e);
        }

        console.log('[Video component] terminando handleSubtitlesParser');
        this.setState({ subtitleparser: subtitlesParser });
    }

    componentWillUnmount() {
        FirstTimeShowModalPinObserver.unsubscribe(this.firstTimeModalPin);
        AlreadyPlayChannelObserver.unsubscribe(this.alreadyPlay);
        this.player.deinit();
        document.removeEventListener(settings.end_vod_fire_event, this.handleSubtitlesEndPlayer);
        document.removeEventListener(settings.show_epg, this.handleEpgVisibility);
        document.removeEventListener('keydown', this.keyPressHandler, false);
        document.removeEventListener(
            settings.event_change_network_status,
            this.handleNetworkDisconnection
        );
    }

    handleEpgVisibility(e) {
        const showEpg = e.detail ? e.detail : e;
        if (this.state.showEpg !== showEpg) {
            if (showEpg === true) this.setState({ showEpg });
            // Si se oculta, se resetea el filtro
            else this.setState({ showEpg, filterEpg: null });
        }
    }

    onCanPlay() {

        NewRelic.actionText('onCanPlay')

        if (!this.isPlayerFull) return;

        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.onCanPlay) {
            this.refs.nplayerControls.onCanPlay();
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.onCanPlay) {
            this.refs.playerControls.onCanPlay();
        }

        if (this.deviceAttachAlreadyResponsed) {
            //si respondio deviceAttach aqui enviamos el evento, en caso de VOD estara en true la bandera
            //para LIVE enviamos 0 y para VOD si tiene bookmark lo enviamos

            console.log('[ERRR] this.AAFResolvedParams ' + typeof this.AAFResolvedParams.isLive);

            const time = this.AAFResolvedParams.isLive
                ? 0
                : this.AAFResolvedParams.resume
                ? this.AAFResolvedParams.resume
                : this.getCurrentTime();
            const { AAFResolvedParams: { streamContentType = null } = {} } = this;
            // Youbora sólo para video
            if (
                streamContentType &&
                streamContentType !== AAF_CONTENT_IS_AUDIO &&
                streamContentType !== AAF_CONTENT_IS_RADIO
            ) {
                TrackerManager.playing(time);
            }
        } else {
            //seteamos bandera para que el evento sea enviado en onResolveParams si se ejecuta primero onCanPlay
            this.videoCanPlay = true;
        }
    }

    onBufferStart(evt, params) {
        if (!this.isPlayerFull) return;
        if (this.refs.playerControls && this.refs.playerControls.onBufferStart) {
            this.refs.playerControls.onBufferStart();
        }

        // if(params && params.stream_type) // AAFPlayer Quitar esto después cuando se quite el old video component
        TrackerManager.bufferStart();
    }

    onBufferEnd(evt, params) {
        if (!this.isPlayerFull) return;
        if (this.refs.playerControls && this.refs.playerControls.onBufferEnd) {
            this.refs.playerControls.onBufferEnd();
        }
        // if(params && params.stream_type) // AAFPlayer Quitar esto después cuando se quite el old video component
        TrackerManager.bufferEnd();
    }

    stopTickOnPause() {
        /**
         * If android then nothing to do, android already send
         * its tick in both play & pause, so its ok
         */
        if (this.isAndroidPlatform()) return;
        if (!this.tickOnPauseIntervalId) return;

        console.log('[TKING] stopTickOnPause*****');

        clearInterval(this.tickOnPauseIntervalId);
        this.tickOnPauseIntervalId = null;
    }

    handleTickOnPause() {
        /**
         * If android then nothing to do, android already send
         * its tick in both, play & pause, so its ok
         */
        if (this.isAndroidPlatform()) return;

        if (!this.AAFResolvedParams) return;

        /**
         * Only VOD and NPVR
         */
        let sendTickOnPause = false;
        const { streamContentType = null } = this.AAFResolvedParams;
        if (streamContentType) {
            /**
             * Add streamContentType as we need
             */
            switch (streamContentType) {
                case AAF_CONTENT_IS_VOD:
                case AAF_CONTENT_IS_NPVR:
                    sendTickOnPause = true;
                default:
                    break;
            }
        }

        // Si no es vod o npvr, nada que hacer
        if (!sendTickOnPause) return;

        // Just in case
        this.stopTickOnPause();

        // Esta getmedia tiene tick?
        const {
            playerMedia: {
                tracking: { policies: { tick_interval } = {}, urls: { tick = null } = {} } = {},
            } = {},
        } = this.AAFResolvedParams;

        // Si no hay url de tick nada que hacer
        if (!tick) return;
        let tickIntervalMS = (tick_interval || 60) * 1000;
        // Run interval...
        this.tickOnPauseIntervalId = setInterval(() => {
            console.log('[TKING] se envía tick simulado ', this.localCurrentTime);
            TrackerManager.tick(this.localCurrentTime);
        }, tickIntervalMS);
    }

    updateCurrentTime(currentTime, currentTimeForSubtitles) {
        if (!this.isPlayerFull) return;

        // Integracion YOUBORA...
        const streamContentType = this && this.AAFResolvedParams && this.AAFResolvedParams.streamContentType;
        // ... pero youbora sólo para video
        if (
            streamContentType &&
            streamContentType !== AAF_CONTENT_IS_AUDIO &&
            streamContentType !== AAF_CONTENT_IS_RADIO
        ) {
            TrackerManager.setPlayhead(currentTime);
        }

        //console.log('[REPLAY FROM NETWORK DISCONNECTED] [Video component] ' + currentTime);

        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.updateCurrentTime) {
            this.refs.nplayerControls.updateCurrentTime(currentTime);
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.updateCurrentTime) {
            this.refs.playerControls.updateCurrentTime(currentTime);
        }

        this.setCurrentTime(currentTime, currentTimeForSubtitles);

        /**
         * Los player de android no pasan por aquí para mandar el track/tick
         * Estos players generan su propio interval
         */

        if (this.isAndroidPlatform()) return;

        if (this.AAFResolvedParams.resume !== currentTime) {
            //Cuando empieza con bookmark evitamo que se envie primero que track start
            // console.error(
            //     '[======] updateCurrentTime (this.AAFResolvedParams.resume !== currentTime)'
            // );
            // Cuando empieza con bookmark evitamo que se envie primero que track start
            let tickInterval = PlayerTracker.policies.tickInterval;
            if (streamContentType === AAF_CONTENT_IS_AUDIO) {
                tickInterval = AudioTracker.policies.tickInterval;
            }
            if (currentTime - this.lastUpdate > tickInterval) {
                this.lastUpdate = currentTime;
                console.log('[TKING] updateCurrentTime sending tick...');

                // Puede haber devices que aún estando en pausa sigan enviando el
                // currentTime ¿? si es el caso, entonces llegarian aquí
                // Y si llegan entonces bloqueamos el tick ¿?
                if (this.tickOnPauseIntervalId) return;

                TrackerManager.tick(currentTime);
            } else if (currentTime - this.lastUpdate < 0) {
                this.lastUpdate = currentTime;
            }
        }
    }

    updateDurationTime(duration) {
        if (!this.isPlayerFull) return;

        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.onDurationChange) {
            this.refs.nplayerControls.onDurationChange(duration);
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.updateDurationTime) {
            this.refs.playerControls.updateDurationTime(duration);
        }
    }

    onPlayingSong() {
        if (!this.isPlayerFull) return;
        // Inicia interval para medir tiempo real de reproducción, los android inician el interval en el método de este mismo componente: handleTick
        if (
            this.AAFResolvedParams &&
            this.AAFResolvedParams.streamContentType &&
            this.AAFResolvedParams.streamContentType === AAF_CONTENT_IS_AUDIO &&
            !this.isAndroidPlatform()
        ) {
            TrackerManager.startTimePlaying();
        }
        if (this.state.subtitleparser.subtitle) {
            this.resetSubtitlesParser();
        }
        if (this.refs.playerControls && this.refs.playerControls.onPlayingSong) {
            this.refs.playerControls.onPlayingSong();
        }
    }

    onPlayingRadio() {
        if (!this.isPlayerFull) return;
        if (this.state.subtitleparser.subtitle) {
            this.resetSubtitlesParser();
        }
        if (this.refs.playerControls && this.refs.playerControls.onPlayingRadio) {
            this.refs.playerControls.onPlayingRadio();
        }
    }

    onFinishSong() {
        if (!this.isPlayerFull) return;
        if (this.refs.playerControls && this.refs.playerControls.onFinishSong) {
            this.refs.playerControls.onFinishSong();
        }
    }

    /**
     * Recuperar tiempo REAL de playing del track & reset del interval & send de la métrica de música
     */
    sendMusicMetrics = () => {
        const secondsPlayingAudio = TrackerManager.getAudioTimePlaying();
        const state = store.getState();
        const user = state.user.musicUser;

        TrackerManager.resetTimePlaying();

        if (user.hasSubscription) {
            //* Se manda la api de tracking/success
            TrackerManager.end(secondsPlayingAudio);
        }
    };

    async onPlaying(params) {

        const { streamType, player, text } = params || {};
        if (streamType === 'VOD' && player === 'ADR') {
            if (AAFPlayer.getCurrentPlayingState(false) === AAFPLAYER_STOP && !LayersControl.isPlayerVisible()) {
                // termino de cargar, pero el usuario ya salio del player.
                AAFPlayer.setForceStopPlayer(true);
                this.stopPlayer();
            }
        }
    }

    async onEnded(params) {
        if (!this.isPlayerFull) return;
        // AAFPlayer on ended
        console.log('[AAFPlayer] player onEnded player', params);
        // Update state of players to 'not playing' when content reached end of the content (or back key)
        if (
            params.streamType === playerConstant.AUDIO ||
            params.streamType === playerConstant.RADIO
        ) {
            const state = store.getState();
            const user = state.user.musicUser;

            /**
             * Recuperar tiempo REAL de playing del track & reset del interval & send de la métrica de música
             */
            if (params.streamType === playerConstant.AUDIO) {
                this.sendMusicMetrics();
            }

            MusicUtils.checkSinglePlay(user)
                .then((singlePlayResponse) => {
                    if (singlePlayResponse.success !== true) {
                        const { error: { code = '' } = {} } = singlePlayResponse;
                        // playing simultáneo
                        if (code === 'CMS_049') {
                            store.dispatch(showModalSinglePlay());
                        } else {
                            this.onFinishSong();
                        }
                    } else {
                        this.onFinishSong();
                    }
                })
                .catch((err) => {
                    this.onFinishSong();
                });
        } else {
            // TODO check reset en player (onfinish event)
            TrackerManager.end(this.getCurrentTime(), params.streamType);
            TrackerManager.stopTicking(params.streamType);
        }

        if(this.nextEpisodeToPlay) {
            const changingEpisodaData = {
                seasonNumber: this.nextEpisodeToPlay.extendedcommon.media.episode.season,
                episodeNumber: this.nextEpisodeToPlay.extendedcommon.media.episode.number,
                episodeTitle: this.nextEpisodeToPlay.title,
                serieTitle:  this.nextEpisodeToPlay.serieTitle,
            }
            store.dispatch(showModal({modalType: MODAL_CHANGING_EPISODE, modalProps: changingEpisodaData}));
            const action = 'ver ahora';
            const label = this.nextEpisodeToPlay.title;

            if (typeof this.props.setMetricsEvent === 'function') {
                this.props.setMetricsEvent({
                    hitType: 'event',
                    eventCategory: 'fin player',
                    eventAction: action,
                    eventLabel: label
                });
                this.props.setMetricsEvent({ type: 'executor' });
                this.sendDimension();
            }

            TrackerManager.episodeChange(0, this.AAFResolvedParams.streamType);
            let languageoptions = null;
            const { extendedcommon: { media: { language: { options: { option }  = {} } = {} } = {} } } = this.nextEpisodeToPlay;
            if(Utils.isNotNullOrNotUndefined(option) && Array.isArray(option)) {
                languageoptions = option;
            }

            const payway_token = this.PBIEpisodeNext && this.PBIEpisodeNext.playButton && this.PBIEpisodeNext.playButton.payway_token;
            const newChapter = {
                payway_token: payway_token,
                playerstate: 'PLAYING',
                source: {
                    videoid: this.nextEpisodeToPlay.id
                },
                ispreview: false,
                islive: false,
                ispip: false,
                ischangeepisode: true,
                //FLAG para no volver a pedir pin para el flujo selector de episodio desde PC
                skipPin: true,
            };
            if(Utils.isNotNullOrNotUndefined(this.nextEpisodeToPlay.recommendations)) {
                newChapter.recommendations = this.nextEpisodeToPlay.recommendations;
            }
            if(Utils.isNotNullOrNotUndefined(languageoptions)) {
                newChapter.languageoptions = languageoptions;
            }
            AAFPlayer.setPlayerState(
                newChapter,
                this.getAAFPlayerWrapper(),
                this.getAAFCallbacks()
            );
        }
        else {
            console.log('[VideoComponent] component onEnded');
            let sendTracking = true;
            if (this.props.player && this.props.player.ispreview) {
                sendTracking = false;
            }
            if (
                params.streamType !== playerConstant.AUDIO &&
                params.streamType !== playerConstant.RADIO
            ) {
                let sendGoBack = true;
                if (this.AAFResolvedParams.currentContentType) {
                    switch (this.AAFResolvedParams.currentContentType) {
                        case AAF_CONTENT_IS_TV:
                        case AAF_CONTENT_IS_TIMESHIFT:
                            LayersControl.showUX();
                            sendGoBack = false;
                            break;
                        case AAF_CONTENT_IS_CATCHUP:
                            await this.modalEndPlayerCatchup();
                            // return
                            return
                        case AAF_CONTENT_IS_VOD:
                            // Se cierra la modal de endplayer, si es que está visible
                            if (store.getState().modal.modalType === MODAL_END_PLAYER2) {
                                store.dispatch({
                                    type: HIDE_MODAL,
                                    modalType: MODAL_END_PLAYER2,
                                });
                            }

                            const typeModal = store.getState().modal.modalType;

                            //* Se cierra la modal de episodios, si es que está visible
                            if (typeModal === MODAL_OPTIONS_EPISODES) {
                                store.dispatch({
                                    type: HIDE_MODAL,
                                    modalType: MODAL_OPTIONS_EPISODES,
                                });
                            }

                            break;
                        default:
                            break;
                    }
                }

                if (sendGoBack) {
                    this.goBack(sendTracking);
                }

                store.dispatch(
                    playFullMedia({
                        //dispatch para actualizar el estado del player en el fin player
                        ispip: false,
                        islive: this.AAFResolvedParams.isLive,
                        playerstate: AAFPLAYER_STOP,
                    })
                );


            }

            /* Actualiza el bookmark de la vCard al finalizar la reproducción del contenido*/
            if (this.AAFResolvedParams.currentContentType === AAF_CONTENT_IS_VOD) {
                if(!params.isTrailer) {
                    const progress = 100;
                    const videoid = this.AAFResolvedParams.groupId;
                    setTimeout(() => {
                        document.dispatchEvent(
                            new CustomEvent(settings.update_progress, { detail: { progress, videoid } })
                        );
                    }, 250);
                }
            }
        }
    }

    updateAllEgps = () => {
        console.log('[Video] actualizando epgs');
        this.AllEpgs = false;
        this.forceUpdate();
        setTimeout(() => {
            console.log('[Video] se actualizaron epgs');
            this.AllEpgs = true;
            this.forceUpdate();
        }, 5000);
    };

    firstTimeModalPin = () => {
        this.isFirstTimeShowModalPin = true;
    };

    alreadyPlay = () => {
        this.alreadyPlayChannel = true;
    };

    async componentDidMount() {
        FirstTimeShowModalPinObserver.subscribe(this.firstTimeModalPin);
        AlreadyPlayChannelObserver.subscribe(this.alreadyPlay);
        if (this.props.updateApp.length === 0) this.props.updateApp.push(this.updateAllEgps);
        this.initTrackerManager();

        /**
         * Este método se manda a llamar cuando se obtiene la respuesta success de getmedia
         * tanto en live (fast play y no fast play como en vod)
         */
        EventEmitter.on('player:setupTracker', async (data) => {
            if (data.isVideo) {
                const isLive =
                data &&
                data.data &&
                data.data.response &&
                data.data.response.group &&
                data.data.response.group.common &&
                data.data.response.group.common.extendedcommon &&
                data.data.response.group.common.extendedcommon.media &&
                data.data.response.group.common.extendedcommon.media.islive === '1';
                const groupId =
                    data && data.data && data.data.entry && data.data.entry.group_id
                        ? data.data.entry.group_id
                        : '';

                try {
                    if (data.data && (data.data.outputParams.streamContentType === AAF_CONTENT_IS_STARTOVER || data.data.outputParams.streamContentType === AAF_CONTENT_IS_TV)) {
                        await this.getDeviceAttach(groupId);
                    }
                }
                catch(err) {
                    console.log('+++++++++++| Catch del await this.getDeviceAttach(groupId);');
                };
                // Si es live
                if (isLive) {
                    await modalInactivityStartLIVESeries()
                    // lanzar el device attach
                    const { data: { outputParams = null } = {} } = data;

                    if (
                        outputParams.streamContentType &&
                        outputParams.streamContentType === AAF_CONTENT_IS_TV
                    ) {
                        await this.deviceAttachInTrackerManager(outputParams, groupId);
                    }
                    this.setupTrackerManagerAttached(data, isLive, groupId);

                    // Si es fast play
                    const { playerMedia: { media: { epgurlresolved = null } = {} } = {} } =
                        outputParams;
                    if (epgurlresolved) {
                        TrackerManager.playing(0);
                    }
                } else {
                    this.setupTrackerManagerAttached(data, isLive, groupId);
                }
            } else {
                TrackerManager.setup(data.data, null, AAF_CONTENT_IS_AUDIO);
            }
        });

        document.addEventListener(settings.end_vod_fire_event, this.handleSubtitlesEndPlayer);
        // TODOAAFPlayer manejar pip y full
        AAFPlayer.setup(this.getAAFPlayerWrapper(), this.getAAFCallbacks());
        document.addEventListener(settings.end_vod_fire_event, this.handleSubtitlesEndPlayer);
        document.addEventListener(settings.show_epg, this.handleEpgVisibility);
    }

    setupTrackerManagerAttached(data, isLive, groupId) {
      window && window.youboraTrackingPlugin && window.youboraTrackingPlugin.setOptions({'content.isLive': isLive })
        const extraTrackerParams = {
            isLive,
            groupId,
            deviceAttachId: this.responseDeviceAttachResult,
        };
        TrackerManager.setup(data.data, extraTrackerParams, null, this.nextContentStreamType);
        TrackerManager.playerGetMedia();
    }

    componentDidUpdate(props) {
        if (typeof this.props.player.cb === 'function' && this.firstTimeCB) {
            this.props.player.cb();
        }

        if (this.props.player.playerstate && this.props.player.playerstate === 'PLAYING') {
            this.setState({ showMiniEpg: true });
        }
        document.removeEventListener('keydown', this.keyPressHandler, false);
        document.addEventListener('keydown', this.keyPressHandler, false);
        new ChannelSingleton().getChannels().then(this.fillFullChannels.bind(this));
        // Youbora: Se setea y se evitan duplicados en el tipo de subscriciones para youboraParams[1] si es VOD o Live
        const dataStore = store.getState();
        const { islive } = dataStore.player;
        if (typeof islive !== 'undefined') {
            window.youboraParams[1].value = '';
            if (islive) {
                // Se setea el Tipo de abono para youboraParams[2] cuando el contenido es Live, si el contenido es free no lo manda
                if (
                    dataStore.player &&
                    dataStore.player.source &&
                    dataStore.player.source.videoid
                ) {
                    dataStore.linealChannels.filter((item) => {
                        if (item.id === dataStore.player.source.videoid)
                            window.youboraParams[2].value = item.key;
                    });
                }
                if (dataStore.linealChannels) {
                    dataStore.linealChannels.forEach((item) => {
                        if (window.youboraParams[1].value.indexOf(item.key) === -1) {
                            window.youboraParams[1].value +=
                                window.youboraParams[1].value.length === 0
                                    ? item.key
                                    : '-' + item.key;
                        }
                    });
                }
            } else if (
                dataStore &&
                dataStore.user &&
                dataStore.user.paywayProfile &&
                dataStore.user.paywayProfile.subscriptions
            ) {
                dataStore.user.paywayProfile.subscriptions.forEach((item) => {
                    if (window.youboraParams[1].value.indexOf(item.key) === -1) {
                        window.youboraParams[1].value +=
                            window.youboraParams[1].value.length === 0 ? item.key : '-' + item.key;
                    }
                });
            }
        }
    }

    streamIsVideo(streamType) {
        return Utils.streamIsVideo(streamType);
    }

    streamIsAudio(streamType) {
        return Utils.streamIsAudio(streamType);
    }

    // resolveAudioSubtitleFromReplace Play en replace, inicia revisando el lang que seleccionó el user
    resolveAudioSubtitleFromReplace(nextPlayerProps) {
        // Select track and subtitle to start, if any when replace
        let currentSubtitleURL = null;
        let currentAudio = null;
        let subtitle_id = null;

        if (this.playerStreamingUtils.isMultipleStreamType(nextPlayerProps.newSource.streamType)) {
            this.currentStreamType = nextPlayerProps.newSource.streamType;
            if (nextPlayerProps.newSource.selectedDataLang.audio) {
                currentAudio = this.playerStreamingUtils.getAudioToPlay(
                    nextPlayerProps.newSource.selectedDataLang.audio,
                    nextPlayerProps.newSource.playerMedia.group.common.extendedcommon.media.language
                        .options.option
                );
            }

            if (currentAudio && this.platform !== 'workstation') {
                console.log('@@@@@@@@ setAudioTrack from replace url', currentAudio);
                this.setAudioTrack(currentAudio);
            }
            // Subtitle parser multiple?
            if (nextPlayerProps.newSource.selectedDataLang.subtitle) {
                subtitle_id = this.playerStreamingUtils.getSubtitleToPlay(
                    nextPlayerProps.newSource.selectedDataLang.subtitle,
                    nextPlayerProps.newSource.playerMedia.group.common.extendedcommon.media.language
                        .options.option
                );
            }
            if (subtitle_id) {
                currentSubtitleURL = this.playerStreamingUtils.getSubtitleForSelectedLang(
                    subtitle_id,
                    this.multipleLangOptions.subtitles
                );
            }
        }
        // If single
        else {
            if (nextPlayerProps.newSource.selectedDataLang.subtitle) {
                subtitle_id = this.playerStreamingUtils.getSingleSubtitleToPlay(
                    nextPlayerProps.newSource.selectedDataLang.content_id,
                    nextPlayerProps.newSource.playerMedia.group.common.extendedcommon.media.language
                        .options.option
                );
            }
            if (subtitle_id) {
                currentSubtitleURL = this.playerStreamingUtils.getSubtitleForSelectedLang(
                    subtitle_id,
                    this.multipleLangOptions.subtitles
                );
            }
        }
        console.log(
            '[Video component] replace play subtitle & audio: ',
            currentSubtitleURL,
            currentAudio
        );
        // single Run parser
        if (currentSubtitleURL) {
            console.log('[Video components] Parser ON');
            this.handleSubtitlesParser(currentSubtitleURL);
        } else {
            console.log('[Video components] Parser OFF');
            this.resetSubtitlesParser();
        }
    }

    // resolveAudioSubtitleFromStart Play por primera vez, inicia revisando preferencia de idioma desde storage
    resolveAudioSubtitleFromStart(nextPlayerProps) {
        let currentAudio = null;
        let currentSubtitleURL = null;
        // If multiple (content_id must be null)
        if (this.playerStreamingUtils.isMultipleStreamType(nextPlayerProps.streamType)) {
            console.log('[Video component] first play, is multiple', this.multipleLangOptions);
            // Storage first priority
            let option_id_lang = null;
            option_id_lang = DeviceStorage.getItem('default_lang');
            if (option_id_lang) {
                //let lang_id = this.playerStreamingUtils.getLangIDByOptionID(option_id_lang, this.langOptions);
                let subtitle_id = this.playerStreamingUtils.getSubtitleToPlay(
                    option_id_lang,
                    this.langOptions
                );
                let audio_id = this.playerStreamingUtils.getAudioToPlay(
                    option_id_lang,
                    this.langOptions
                );
                console.log(
                    '[Video component] first play, is multiple, lang for storage',
                    option_id_lang,
                    subtitle_id,
                    audio_id,
                    this.langOptions,
                    this.multipleLangOptions
                );
                if (audio_id) {
                    currentAudio = this.playerStreamingUtils.getAudioForSelectedLang(
                        audio_id,
                        this.multipleLangOptions.audio
                    );
                }
                if (subtitle_id) {
                    currentSubtitleURL = this.playerStreamingUtils.getSubtitleForSelectedLang(
                        subtitle_id,
                        this.multipleLangOptions.subtitles
                    );
                }
            } else {
                console.log(
                    '[Video component] first play, is multiple, lang does not come from storage'
                );
                if (this.multipleLangOptions.audio.selected) {
                    currentAudio =
                        this.multipleLangOptions.audio[this.multipleLangOptions.audio.selected];
                }
                if (this.multipleLangOptions.subtitles.selected) {
                    currentSubtitleURL =
                        this.multipleLangOptions.subtitles[
                            this.multipleLangOptions.subtitles.selected
                        ].external;
                }
            }
            // multiple Run parser
            if (currentSubtitleURL) {
                this.handleSubtitlesParser(currentSubtitleURL);
            }
            // multiple Change audio track
            if (currentAudio && this.platform !== 'workstation') {
                this.setAudioTrack(currentAudio);
            }
        }
        // If single (content_id is not null)
        else {
            let subtitle_id = this.playerStreamingUtils.getSingleSubtitleToPlay(
                nextPlayerProps.drmInfo.content_id,
                this.langOptions
            );
            if (subtitle_id) {
                currentSubtitleURL = this.playerStreamingUtils.getSubtitleForSelectedLang(
                    subtitle_id,
                    this.multipleLangOptions.subtitles
                );
                // single Run parser
                if (currentSubtitleURL) {
                    this.handleSubtitlesParser(currentSubtitleURL);
                }
            }
        }
        console.log(
            '[Video component] first play subtitle & audio: ',
            currentSubtitleURL,
            currentAudio
        );
    }

    // INIT ================================================================================================================================================
    // Para el nuevo AAFPlaying:

    getAAFCallbacks() {
        let cbs = {
            onProgress: this.updateCurrentTime,
            onDurationChange: this.updateDurationTime,
            onFinishSong: this.onFinishSong,
            onPlayingSong: this.onPlayingSong,
            onPlayingRadio: this.onPlayingRadio,
            onCanPlay: this.onCanPlay,
            onEnded: this.onEnded,
            onBufferingStart: this.onBufferStart,
            onBufferingFinish: this.onBufferEnd,
            onPlayerError: this.onPlayerError,
            onPlayingVideo:  this.onPlaying,

            // Player event, para enviar tracker manager por si...
            onLoad: this.onLoad.bind(this),

            setLoading: this.setLoading.bind(this),
            clearLoading: this.clearLoading.bind(this),

            // Custom events
            onResolveParams: this.onResolveParams,
            onResolveResizePlayer: this.onResolveResizePlayer,
            onResolveError: this.onResolveError,
            onResolveShowModal: this.onResolveShowModal,
            onResolveAsyncPinFailed: this.onResolveAsyncPinFailed,
            //onDoTimeshift: this.onDoTimeshift,

            // Player controls events
            onPlayerControlPlay: this.onPlayerControlPlay,
            onPlayerControlPause: this.onPlayerControlPause,
            onPlayerControlResume: this.onPlayerControlResume,
            onPlayerControlStop: this.onPlayerControlStop,
            onPlayerControlSeek: this.onPlayerControlSeek,
            onPlayerSetAudioTrack: this.onPlayerSetAudioTrack,

            // Fin player event
            onPlayerEndPlayer: this.onPlayerEndPlayer,
            // Cambio de contenido, stop current playing
            onPlayerStopMedia: this.onPlayerStopMedia,
            changePath: this.goToCard,
            // Evento para tizen
            onReplay: this.tryReplay,
            // Evento para seek tracking
            onBookMark: this.onBookMark,
            onBitrateChange: this.onBitrateChange,
            onTrackInfo: this.ontrackInfo,
            onSkipToLive: this.onSkipToLive
        };

        if (EventTimeshift.isEnabled()) {
            cbs.onTimeshiftEvent = this.onTimeshiftEvent;

            cbs.onSeekStartOver = this.onSeekStartOver;
        }

        // Trick play enable (2x 4X 8X - playing speed)
        if (EventTimeshift.isTrickModeEnabled()) {
            cbs.onRateChange = this.onRateChange;
        }

        cbs.onFireTPA = this.onFireTPA;
        cbs.onResultFireTPA = this.onResultFireTPA;

        return cbs;
    }

    /**
     * TODO
     */
    getAAFPlayerWrapper() {
        return this.refs.VideoContainer;
    }

    getDuration() {
        if (!this.isPlayerFull) return;
        if (
            this.AAFResolvedParams &&
            this.AAFResolvedParams.streamType === playerConstant.AUDIO &&
            store.dispatch(isPreviewSong())
        ) {
            return '30';
        } else {
            return AAFPlayer.getDuration();
        }
    }

    onPlayerControlPlay(params) {
        if (!this.isPlayerFull) return;
    }

    onPlayerControlPause(params, timeshiftAllowed) {
        console.log('[TKING] Video/index onPlayerControlPause');
        if (!this.isPlayerFull) return;
        if (
            params.streamType !== playerConstant.AUDIO &&
            params.streamType !== playerConstant.RADIO
        ) {
            if (params.isLive && timeshiftAllowed) {
                this.timeShift = new Dates().format('YYYY/MM/DD hh:mm:ss');
            }
            this.handleTickOnPause();
            TrackerManager.pause(this.getCurrentTime(), params.streamType);
        }
        if (params.streamType === playerConstant.AUDIO) {
            TrackerManager.pauseTimePlaying();
        }
    }

    onPlayerControlResume(inputPlayerParams, outputPlayerParams) {
        if (!this.isPlayerFull) return;
        console.log('[TKING] onPlayerControlResume');
        this.stopTickOnPause();

        TrackerManager.resume(this.getCurrentTime(), outputPlayerParams.streamType);
        /**
         * Reinicia interval de tiempo REAL de reproducción de audio
         */
        if (outputPlayerParams.streamType === playerConstant.AUDIO) {
            TrackerManager.startTimePlaying();
        }
        // Se necesita hacer timeshift?
        let ofFull = false; // timeshift solo sobre full
        /*
     if (inputPlayerParams.islive && AAFPlayer.getCurrentContentType(ofFull) === AAF_CONTENT_IS_TIMESHIFT) {
     // Hacer un nuevo timeshift, donde se quedó la pausa
     if(this.timeShift) {
     inputPlayerParams.starttime = this.timeShift;
     this.performTimeShift(inputPlayerParams);
     }
     }
     */
    }

    onPlayerControlStop(params) {
        if (!this.isPlayerFull) return;
        this.stopTickOnPause();
        TrackerManager.stopTicking(this.getCurrentTime(), params.streamType);
    }

    onPlayerControlSeek(params, seconds) {
        if (!this.isPlayerFull) return;
        const seekObject = {
            seek_start: this.getCurrentTime(),
            seek_end: seconds,
            seek_time: seconds - this.getCurrentTime(),
        };
        TrackerManager.seek(seekObject, params.streamType);
    }

    onPlayerSetAudioTrack(params) {
        if (!this.isPlayerFull) return;
        //TrackerManager.audioChange(this.getCurrentTime(), params.streamType);
    }

    onPlayerEndPlayer(params) {
        if (!this.isPlayerFull) return;
        TrackerManager.credits(this.getCurrentTime(), params.streamType);
    }

    /**
     * Callback enviado cuando el player va a terminar de playear (por ejemplo un stop o un cambia de playear live a música, o vod a live y así)
     *
     * @param {*} inputParams los params inmediatos anteriores que se le enviaron al player, antes de hacer el cambio de vod a live por ejemplo
     * @param {*} outputParams los params inmediatos anteriores que resolvió el player, antes de hacer el cambio de vod a live por ejemplo
     * @param {*} seconds when player stop content (or change video type, for example when pass from live to vod, or from vod to live)
     * @param isChangeEpisodeOrLang
     */
    onPlayerStopMedia(inputParams, outputParams, seconds, isChangeEpisodeOrLang) {
        if (!this.isPlayerFull) return;
        this.nextEpisodeToPlay = null; // Reset automatic play episode when user closes endplayer
        if (this.refs.nplayerControls && this.refs.nplayerControls.onStopMediaPlay) {
            this.refs.nplayerControls.onStopMediaPlay();
        }

        // Estaba playeando?
        if (inputParams.playerstate === AAFPLAYER_PLAY) {
            // Para audio
            if (outputParams && outputParams.streamType === playerConstant.AUDIO && seconds !== 0) {
                store.dispatch(sendMetricsMusicaStarted(seconds));
            }
            // Reset interval, realtime playing audio track
            if (inputParams.streamContentType === AAF_CONTENT_IS_AUDIO) {
                TrackerManager.resetTimePlaying();
            }
            if (inputParams.streamContentType === AAF_CONTENT_IS_VOD) {
                this.resetSubtitlesParser();

                // Se cierra la modal de endplayer, si es que está visible
                if (store.getState().modal.modalType === MODAL_END_PLAYER2) {
                    store.dispatch({
                        type: HIDE_MODAL,
                        modalType: MODAL_END_PLAYER2,
                    });
                }
            }

            // Para vod, send stop track
            if (
                inputParams.source &&
                (Utils.isNotNullOrNotUndefined(inputParams.source.videoid) ||
                    Utils.isNotNullOrNotUndefined(inputParams.source.videosource))
            ) {
                if (!inputParams.islive) {
                    if (
                        this.AAFResolvedParams &&
                        this.AAFResolvedParams.resume > 0 &&
                        seconds == 0
                    ) {
                        seconds = this.AAFResolvedParams.resume;
                    }
                    this.stopTickOnPause();
                    TrackerManager.stop(seconds);

                    //FIX https://dlatvarg.atlassian.net/browse/STV-6331
                    const duration = this.getDuration();
                    let currentP = store.getState().resume.progress
                        ? store.getState().resume.progress
                        : 0;
                    let progress = null;
                    if (
                        this.AAFResolvedParams &&
                        this.AAFResolvedParams.resume === 0 &&
                        seconds === 0
                    ) {
                        progress = currentP;
                    } else {
                        progress =
                            parseInt(duration) === 0
                                ? currentP
                                : Math.ceil((parseFloat(seconds) / parseFloat(duration)) * 100);
                    }

                    // FIX https://dlatvarg.atlassian.net/browse/STV-10165
                    // no Mandar un progress mayor que la duracion del contenido
                    // para que el servicio de SPRITES no regrese 404
                    if (
                        this.AAFResolvedParams &&
                        this.AAFResolvedParams.playerMedia &&
                        this.AAFResolvedParams.playerMedia.media &&
                        this.AAFResolvedParams.playerMedia.media.duration &&
                        this.AAFResolvedParams.playerMedia.media.duration.seconds
                    ) {
                        const durationTotal = parseInt(
                            this.AAFResolvedParams.playerMedia.media.duration.seconds
                        );

                        if (progress > durationTotal) {
                            progress = durationTotal;
                        }
                    }
                    if (this.AAFResolvedParams && !this.AAFResolvedParams.isTrailer) {
                        store.dispatch(
                            setResumeData({
                                progress,
                            })
                        );
                    }

                    if(!inputParams.ispreview) {
                        setTimeout(() => {
                            document.dispatchEvent(
                                new CustomEvent(settings.update_progress, {
                                    detail: { progress, videoid: inputParams.source.videoid },
                                })
                            );
                        }, 250);
                    }
                } else {
                    if (inputParams.streamContentType) {
                        switch (inputParams.streamContentType) {
                            case AAF_CONTENT_IS_TV:
                            case AAF_CONTENT_IS_STARTOVER:
                                this.stopTickOnPause();
                                TrackerManager.stop(null, null, null, true, [
                                    'YouboraTracker',
                                    'PlayerTracker',
                                ]);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }

            if (!isChangeEpisodeOrLang) {
                TrackerManager.leaveContent(seconds);
            }
        }
    }

    /**
     * TODO optimizar
     *
     * @param {*} seconds
     * @param {*} params
     */

    /*
   onDoTimeshift(seconds, params) {
   if(!this.isPlayerFull) return;
   if (!this.timeShift || !isNaN(this.timeShift)) {
   this.timeShift = m().unix();
   }
   const safeTime = this.getSafeTime();
   this.timeShift += seconds + safeTime;
   const _this = this;
   if (this.waitingSeek) clearTimeout(this.waitingSeek);
   this.waitingSeek = setTimeout(() => {
   const currentTime = m().unix();
   const time = _this.timeShift > currentTime ? currentTime : _this.timeShift;
   _this.timeShift = m.unix(time).format("YYYY/MM/DD hh:mm:ss");
   _this.performTimeShift(params);
   }, 1000);
   }
   */

    /**
     *  @param timeshiftData = {
     *    backward: isBackward,
     *    // Si es negativo o no, se verifica en video/component, quien es quien decide
     *    // si se va o no a pgm o solo hace seek sobre el actual playing
     *    seektime: this.state.channelInfo.timeshiftAllowed - this.state.timeshiftTime ,
     *    maxtimeshiftallowed
     *  };
     */
    setTimeshiftSeek(timeshiftData, firstSeek) {
        if (EventTimeshift.isEnabled()) {
            AAFPlayer.seekStartOver(timeshiftData.seektime, firstSeek);
        } else {
            AAFPlayer.seekTimeshift(timeshiftData, firstSeek);
        }
    }

    /**
     * Método para hacer startover, timeshift nueva experiencia
     * Se mantiene timeshiftData como nombre de variable aunque
     * es startOver
     * starttime as unix timestamp seconds (comes with safeTime)
     * endtime as unix timestamp seconds
     */
    doStartOver(groupId, starttime, endtime, timeshiftData, isStartOver) {
        new ChannelSingleton().getTimeshiftToken(groupId).then((timeshifttoken) => {
            let currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions(false);
            if (
                currentPlayerOptions.source &&
                !Utils.isNullOrUndefined(currentPlayerOptions.source.videoid)
            ) {
                // En starttime viene el valor que quiere regresar el user
                // Actualmente el player ya está playeando en startover?
                if (
                    Utils.isNotNullOrNotUndefined(currentPlayerOptions.starttime) &&
                    starttime !== null &&
                    Utils.isNotNullOrNotUndefined(currentPlayerOptions.endtime) &&
                    endtime !== null
                ) {
                    // Se hace un seek sobre el actual playing que ya es timeshift
                    timeshiftData.starttime = this.timeShift.starttime;
                    timeshiftData.endtime = this.timeShift.endtime;
                    this.setTimeshiftSeek(timeshiftData, false);
                } else {
                    // manda pgm con los nuevos params
                    currentPlayerOptions.source.videoid = groupId;
                    currentPlayerOptions.starttime = starttime;
                    currentPlayerOptions.endtime = endtime;
                    // Agregar paywayToken
                    currentPlayerOptions.payway_token = timeshifttoken;

                    // Aquí ajustar el streamContentType para pasar de live a startover
                    if (
                        currentPlayerOptions.streamContentType &&
                        currentPlayerOptions.streamContentType === AAF_CONTENT_IS_TV
                    ) {
                        currentPlayerOptions.streamContentType = AAF_CONTENT_IS_STARTOVER;
                    }

                    //console.log('[STVOFFSET] Video/index seekTime inicial: ' + timeshiftData.seektime);
                    //console.log('[STVOFFSET] Video/index inicio del evento: ' + starttime);

                    let safeSeekTime = this.getStartoverSafeTime(timeshiftData.seektime, starttime);

                    //console.log('[STVOFFSET] Video/index *********** el resultado del seek inicial es: ' + safeSeekTime);
                    timeshiftData.seektime = safeSeekTime;

                    currentPlayerOptions.timeshiftData = timeshiftData;
                    currentPlayerOptions.isStartOver = isStartOver === true;

                    if (this.refs && this.refs.playerControls) {
                        this.refs.playerControls.hide();
                    }

                    this.performTimeShift(currentPlayerOptions);
                }
                this.timeShift = timeshiftData;
            }
        });
    }

    getStartoverSafeTime(firstSeek, eventBegin) {
        //console.log('[STVOFFSET] Video/index getStartoverSafeTime enter');
        // Nombre de la llave: startover_event_safe_time
        const metadataStartoverEventSafeTimeValue =
            '{"default": { "seconds": 0 }, "colombia": {"seconds": -40}}';

        const region = DeviceStorage.getItem('region');
        let _safeTime = Metadata.get(
            'startover_event_safe_time',
            metadataStartoverEventSafeTimeValue
        );
        let safeTime = JSON.parse(_safeTime);

        const safeTimeRegionExists = safeTime[region] && !isNaN(safeTime[region].seconds);
        let seekSafeTime = 0;
        if (safeTimeRegionExists) {
            seekSafeTime = safeTime[region].seconds;
        } else {
            seekSafeTime =
                safeTime['default'] && !isNaN(safeTime['default'].seconds)
                    ? safeTime['default'].seconds
                    : 0;
        }

        if (!isNaN(seekSafeTime)) {
            //console.log('[STVOFFSET] Video/index getStartoverSafeTime seekSafeTime desde metadata es : ' + seekSafeTime);
            firstSeek = firstSeek + seekSafeTime;
            //console.log('[STVOFFSET] ++++ Video/index getStartoverSafeTime firstSeek + seekSafeTime es : ' + firstSeek);
            if (firstSeek < 0) {
                firstSeek = 0;
            } else {
                let justNow = Utils.nowAsTimestampSeconds();
                //console.log('[STVOFFSET] Video/index justNow ' + justNow);
                let maxForwardTime = justNow - eventBegin;
                //console.log('[STVOFFSET] Video/index maxForwardTime ' + maxForwardTime);

                if (firstSeek > maxForwardTime) {
                    firstSeek = maxForwardTime - 5; // 5 segundos de protección
                }
            }
        }

        return firstSeek;
    }

    /**
     * Método para hacer timeshift, cuando se manda este request desde playerControls
     * TODO, parece que onDoTimehsift sale sobrando :S, confirmar
     *
     * Si starttime viene nulo es quiza porque ya alcanzaron nuevamente el "tiempo actual" de la aplicación
     *
     */
    doTimeshift(groupId, starttime, timeshiftData) {
        new ChannelSingleton().getTimeshiftToken(groupId).then((timeshifttoken) => {
            let currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions();
            if (
                currentPlayerOptions.source &&
                !Utils.isNullOrUndefined(currentPlayerOptions.source.videoid)
            ) {
                // En starttime viene el valor que quiere regresar el user
                // Actualmente el player ya está playeando en timeshift?
                if (
                    Utils.isNotNullOrNotUndefined(currentPlayerOptions.starttime) &&
                    starttime !== null
                ) {
                    // Se hace un seek sobre el actual playing que ya es timeshift
                    timeshiftData.starttime = this.timeShift.starttime;
                    this.setTimeshiftSeek(timeshiftData, false);
                } else {
                    // manda pgm con los nuevos params
                    currentPlayerOptions.source.videoid = groupId;
                    //currentPlayerOptions.starttime = this.timeShift;
                    // Get a moment object with starttime:
                    let momentStarttime = this.getStarttimeTimeshift(groupId);
                    currentPlayerOptions.starttime =
                        starttime !== null ? momentStarttime.format('YYYY/MM/DD hh:mm:ss') : null;
                    currentPlayerOptions.starttime =
                        starttime !== null
                            ? momentStarttime.unix() /*.format("YYYY/MM/DD hh:mm:ss")*/
                            : null;
                    // Agregar paywayToken
                    currentPlayerOptions.payway_token = timeshifttoken;
                    // Si no viene null, entonces realmente es un timeshift, si viene null quiza el user "alcanzo de nuevo" el now() sobre la barra/bootones de progreso
                    // (se puso en la barra nuevamente hasta la derecha)
                    if (starttime !== null) {
                        timeshiftData.starttime = momentStarttime.unix();
                        currentPlayerOptions.timeshiftData = timeshiftData;
                    } else if (
                        timeshiftData &&
                        Utils.isNotNullOrNotUndefined(timeshiftData.timeshiftDelay)
                    ) {
                        currentPlayerOptions.timeshiftData = timeshiftData;
                    }

                    this.performTimeShift(currentPlayerOptions);
                }
                this.timeShift = timeshiftData;
            }
        });
    }

    getStarttimeTimeshift(groupId) {
        return this.playerStreamingUtils.getStarttimeTimeshift(groupId);
    }

    /**
     *
     *
     * @param {*} seconds
     * @param {*} params
     */
    performTimeShift(params) {
        if (!this.isPlayerFull) return;
        // TODO en caso de pausa, guardar los params de llamada al player¿? para hacer un nuevo timeshift?
        // Sólo necesitamos el groupid para hacer el timeshift
        store.dispatch(playFullMedia(params));
        //AAFPlayer.setPlayerState(params, this.getAAFPlayerWrapper(), this.getAAFCallbacks());
    }

    /**
     *
     * @param {*} evt
     * @param {*} params
     */
    onLoad(evt, params) {
        //console.error('&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& ***********************************> enter video/index onLoad 1 getCurrentTime: ' + this.getCurrentTime()) ;
        this.loaded = true;
        console.log('MARIANO onLoad ', this.loaded);
        this.onChangingChannel(false);
        this.clearLoading();
        if (!this.isPlayerFull) return;
        /*if(params && params.stream_type) {// AAFPlayer Quitar esto después cuando se quite el old video
     TrackerManager.startTicking(params.streamType);
     TrackerManager.playing();
     }*/
    }

    /**
     *
     * @param {*} params
     * Aquí lanzar tracker ¿?
     * Lanzar multiple audio y subtitulo inicial y demás cosas que deban lanzarse
     */
    afterGetDataSe(x) {
        // if( this.refs.playerControls &&  this.refs.playerControls.refs &&  this.refs.playerControls.refs.seasons &&  this.refs.playerControls.refs.seasons.style) {
        if (this.refs.nplayerControls && this.refs.nplayerControls.setSerieData) {
            let localSerieData = {
                seasons: x.seasons,
                seasonNumber: '1',
                episodeNumber: '1',
            };
            if (this.AAFResolvedParams && this.AAFResolvedParams.playerMedia) {
                if (
                    this.AAFResolvedParams.playerMedia &&
                    this.AAFResolvedParams.playerMedia.group &&
                    this.AAFResolvedParams.playerMedia.group.common &&
                    this.AAFResolvedParams.playerMedia.group.common.extendedcommon &&
                    this.AAFResolvedParams.playerMedia.group.common.extendedcommon.media &&
                    this.AAFResolvedParams.playerMedia.group.common.extendedcommon.media.episode
                ) {
                    localSerieData.episodeNumber =
                        this.AAFResolvedParams.playerMedia.group.common.extendedcommon.media.episode.number;
                    localSerieData.seasonNumber =
                        this.AAFResolvedParams.playerMedia.group.common.extendedcommon.media.episode.season;
                }
            }
            this.serieData = localSerieData;
            this.refs.nplayerControls.setSerieData(localSerieData);
        }
    }

    onResolveResizePlayer(inputParams) {
        /**
         * Para controlar e recordatorios, por el momento...agregar aquí demás condiciones
         * o flujos para controlar durante un resize (que implica un "quiero playear o entro
         * a playear el mismo contenido que ya se esta reproduciendo")
         */
        // Si esta en video

        if (inputParams.source) {
            this.onChangingChannel(false);
            if (
                Utils.isNotNullOrNotUndefined(inputParams.source.videoid) ||
                Utils.isNotNullOrNotUndefined(inputParams.source.videosource)
            ) {
                // Si no es pip y si no es preview
                if (!inputParams.ispip && !inputParams.ispreview) {
                    // Si hizo un resize a full?
                    if (inputParams.size && inputParams.size.width > 1279) {
                        this.props.setAafLiveHistory(inputParams); // set for live player history
                        if (!LayersControl.isPlayerVisible()) {
                            LayersControl.showPlayer();
                        }
                    }

                    /**
                     * Si es resize a pip, ps4, cerrado sólo a ps4 [STV-9130]
                     * El resize sólo se hace desde algún flavour live
                     *
                     */
                    if (
                        inputParams.size &&
                        inputParams.size.width < 1280 &&
                        this.platform === 'ps4'
                    ) {
                        console.log('[PAU] Video/index onResolveResizePlayer dspatch 2!');
                        store.dispatch(
                            setResumeData({
                                previewImage: null,
                            })
                        );
                    }
                }
            }
        }
    }
    sendDimension = () => {
        const payload = new AnalyticsDimensionSingleton().getPayload();
        // console.log('[PAYLOAD] video/index sendDimension::payload: ', payload);
        this.props.setMetricsEvent(payload);
        this.props.setMetricsEvent({ type: 'executor' });
    };

    sendVirtualPage = (virtualPage) => {
        if (typeof this.props.setMetricsEvent === 'function') {
            this.props.setMetricsEvent({
                hitType: 'pageview',
                page: virtualPage,
            });
            this.props.setMetricsEvent({ type: 'executor' });
        }
    };

    sendMetric = (pgm, isLive, isTrailer = false) => {
        if (typeof this.props.setMetricsEvent === 'function' && pgm && pgm.group) {
            let action = 'play',
                label,
                virtualPage = 'reproductor/',
                provider =
                    pgm.group.common.extendedcommon.media.proveedor.nombre !== 'AMCO'
                        ? pgm.group.common.extendedcommon.media.proveedor.nombre
                        : '';
            if (isLive) {
                action += '/screen';
                label = `tv - ${provider} - ${pgm.group.common.title}`;
                virtualPage += `  tv - ${provider} ${pgm.group.common.title}`;
            } else {
                //vod
                label = `${pgm.group.common.extendedcommon.format.types}${
                    provider !== '' ? ' - ' + provider : ''
                }`;
                virtualPage +=
                    pgm.group.common.extendedcommon.media.proveedor.nombre !== 'AMCO'
                        ? `suscripcion ${provider}`
                        : 'suscripcion';
                action += '/play';
                if (isTrailer) label += ' - trailer ';
                if (pgm.group.common.extendedcommon.media.serie) {
                    //es serie
                    label +=
                        ' - ' +
                        pgm.group.common.extendedcommon.media.serie.title +
                        ':' +
                        pgm.group.common.title;
                    virtualPage +=
                        ' - ' +
                        pgm.group.common.extendedcommon.media.serie.title +
                        ':' +
                        pgm.group.common.title;
                } else {
                    //es pelicula
                    label += ' - ' + pgm.group.common.title;
                    virtualPage += ' - ' + pgm.group.common.title;
                }
            }
            this.sendVirtualPage(virtualPage);
            this.props.setMetricsEvent({
                hitType: 'event',
                eventCategory: 'reproductor',
                eventAction: action,
                eventLabel: label,
            });
            this.props.setMetricsEvent({
                type: 'executor',
            });
            this.sendDimension();
        }
    };

    async getDeviceAttach(groupId) {
        try {
            this.responseDeviceAttachResultWhenError = null;
            const { linealChannels = [] } = store.getState();
            const { purchaseid: purchase_id = null } =
                linealChannels.find((ch) => ch.id === groupId) || {};

            const deviceAttachResult = await deviceAttach(groupId, purchase_id);
            const defaultDeviceId = DeviceStorage.getItem('__UUID__') || null;
            const deviceAttachData = deviceAttachResult.attach ? deviceAttachResult.attach : {};
            const id = deviceAttachData.id ? deviceAttachData.id : defaultDeviceId;

            this.responseDeviceAttachResult = id;

        } catch (err) {
            console.error('Could not set deviceAttachId for tracking tracker', err);
            this.responseDeviceAttachResult = null;
            this.responseDeviceAttachResultWhenError = err;
            throw err;
        }
    }

    async deviceAttachInTrackerManager(outputParams, groupId) {
        const deviceAttachId = this.responseDeviceAttachResult
        const existValueDeviceAttach =  deviceAttachId !== null

        if (!existValueDeviceAttach) {
            const state = store.getState();
            if (state.user.type === IPTV) {
                this.deviceAttachAlreadyResponsed = false; //para que no se mande el track en un error
                return;
            }
            const params = {};
            params.content = {};
            const { code = null } = this.responseDeviceAttachResultWhenError;
            params.content.code = code;
            params.modalMessage = Translator.get('PLY_DEV_00006');
            this.handleCantPlay(params);
            const nullPlayer = {
                ispip: false,
                islive: true,
                playerstate: 'STOPPING',
                event: null,
            };
            store.dispatch(playFullMedia(nullPlayer));
            LayersControl.showUX();
        }

        const extraTrackerParams = {
            isLive: outputParams.isLive,
            groupId,
            deviceAttachId,
        };

        TrackerManager.setupExtraParams(extraTrackerParams, outputParams.isFallback);
        this.deviceAttachAlreadyResponsed = true;
        if (this.videoCanPlay) {
            //si onCanPlay se ejecuto primero aqui enviamos el evento
            TrackerManager.playing(0);
            this.videoCanPlay = false;
        }
    }

    initTrackerManager() {
        let trackers = [];

        if (Utils.isAkamaiEnable()) {
            const akamaiTracker = new AkamaiTracker();
            try {
                AkamaiTracker.loadScript().then(() => {
                    trackers.push(akamaiTracker);
                });
            } catch (ex) {
                console.error('Could not load script for akamai tracker:', ex);
            }
        }

        const playerTracker = new PlayerTracker();
        trackers.push(playerTracker);
        const dashboardTracker = new DashboardTracker();
        trackers.push(dashboardTracker);
        const youboraTracker = new YouboraTracker();
        trackers.push(youboraTracker);
        // Youbora
        if (
            window.youboraTrackingPlugin &&
            window.youboraTrackingPlugin.setAdapter &&
            typeof window.youboraTrackingPlugin.setAdapter === 'function'
        ) {
            window.youboraTrackingPlugin.setAdapter(youboraTracker);
        }
        const audioTracker = new AudioTracker();
        trackers.push(audioTracker);
        new TrackerManager(trackers);
    }

    checkVideo = (outputParams, newPlayerOptions = null) => {
        /**
         * Se limita este método de fallback para las android, que no envian el evento onload de manera confiable,
         * entonces se usa el currentTime en live
         */
        const isNPVR =
            outputParams &&
            outputParams.streamContentType &&
            outputParams.streamContentType === AAF_CONTENT_IS_NPVR;
        switch (this.platform) {
            case 'android':
                if (outputParams.isLive && isNPVR !== true) {
                    if (!AAFPlayer.isPlayerPlaying() || FallbackUtil.getError()) {
                        console.log(
                            '[FALLBACK] NO esta playeando, se hace fallback &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&'
                        );
                        let playerOptions = newPlayerOptions
                            ? newPlayerOptions
                            : AAFPlayer.getCurrentPlayerOptions();
                        console.log(
                            '***** MMMMMMMMMMMM MMMMMMMMMMMMMMMMMMMMMMM *******************  AQUI playerOptions',
                            playerOptions
                        );
                        let deleteLastStreamArray = [];
                        if (Array.isArray(playerOptions.deleteLastStream)) {
                            deleteLastStreamArray = [...playerOptions.deleteLastStream];
                        }
                        deleteLastStreamArray.push(outputParams.streamType);
                        playerOptions.deleteLastStream = deleteLastStreamArray;
                        playerOptions.modalHasBeenShown = true; // Si ya mostro la modal en el primer intento que ya no la muestre
                        const err = FallbackUtil.getError();
                        TrackerManager.playingFallback(outputParams.streamType, err);
                        FallbackUtil.setError(null);
                        FallbackUtil.clearFallback();
                        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: checkVideo'} ${'fallback_streamType_failed:'+  outputParams.streamType}`);

                        store.dispatch(playFullMedia(playerOptions));
                    } else {
                        FallbackUtil.clearFallback();
                        console.log(
                            '[FALLBACK] YA está playeando, NO se hace fallback &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&'
                        );
                    }
                }
                else {
                    FallbackUtil.clearFallback();
                }
                break;
            default:
                FallbackUtil.clearFallback();
                if (
                    !this.loaded &&
                    outputParams.currentContentType === AAF_CONTENT_IS_TV &&
                    isNPVR !== true
                ) {
                    let playerOptions = AAFPlayer.getCurrentPlayerOptions();
                    let deleteLastStreamArray = [];
                    if (Array.isArray(playerOptions.deleteLastStream)) {
                        deleteLastStreamArray = [...playerOptions.deleteLastStream];
                    }
                    deleteLastStreamArray.push(outputParams.streamType);
                    playerOptions.deleteLastStream = deleteLastStreamArray;
                    playerOptions.modalHasBeenShown = true; // Si ya mostro la modal en el primer intento que ya no la muestre
                    const err = FallbackUtil.getError();
                    TrackerManager.playingFallback(outputParams.streamType, err);
                    FallbackUtil.setError(null);
                    store.dispatch(playFullMedia(playerOptions));
                }
                break;
        }

        this.loaded = false;
    };

    /*
     * Método que consulta los canales bloqueados del storage especial y dice si contiene el groupId dado
     */
    isLivePinBlocked(groupId) {
        const { pin_channel } = store.getState().pinCodes;
        let blockedChannelsArray = pin_channel.info ? pin_channel.info : []; //channelBlockedUtil.get('blockedChannels');
        return (
            blockedChannelsArray &&
            blockedChannelsArray.length > 0 &&
            blockedChannelsArray.indexOf(groupId) >= 0
        );
    }

    checkToCloseChangingEpisodeModal() {
        if (Utils.modalType() === MODAL_CHANGING_EPISODE) {
            this.closeModal();
        }
    }

    getEpisodePBI(outputParams) {
        let next = null;
        const statusUser = store.getState().user.userStatus;

        if (
            outputParams.playerMedia &&
            outputParams.playerMedia.next_group &&
            outputParams.playerMedia.next_group.common
        ) {
            next = outputParams.playerMedia.next_group.common;
            //* Se verifica si el usuario es anónimo para obtener el PBI sin token
            if (statusUser === 'anonymous') {
                const withoutToken = true;
                api.getMultiplePBIS({ groupId: next.id }, withoutToken).then(
                    (pbi) => {
                        this.PBIEpisodeNext = pbi.data;
                    }
                ).catch(() => {});
            } else {
                api.PurchaseButtonInfov585({ groupId: next.id }).then(
                    (pbi) => {
                        this.PBIEpisodeNext = pbi;
                    }
                ).catch(() => {});
            }
        }
    }

    onResolveParams(outputParams, inputParams, isReplace) {
        this.PBIEpisodeNext = null;
        this.getEpisodePBI(outputParams);

        this.nextEpisodeToPlay = null;
        this.isTPA = outputParams.isTPA ? true : null;
        this.tpaData = outputParams.isTPA ? outputParams.isTPA : {};
        this.eventFullEpg = null;
        const newPC = this.useNewPlayerControls();
        AlreadyPlayChannelObserver.fire();
        const isNPVR =
            outputParams &&
            outputParams.streamContentType &&
            outputParams.streamContentType === AAF_CONTENT_IS_NPVR;

        if(isNPVR) {
            try {
            if(outputParams.playerMedia) {
                EventEmitter.emit('player:setupTracker', { isVideo: true, data: {
                entry:outputParams.playerMedia.entry,
                outputParams,
                response: outputParams.playerMedia,
                event: inputParams.npvrEvent ? inputParams.npvrEvent : null
                } });
            }
            }
            catch(err) {
            }
        }

        const isLive = outputParams.isLive && isNPVR !== true;
        TrackerManager.setCurrentStreamContentType(outputParams.streamContentType, true);
        this.sendMetric(outputParams.playerMedia, outputParams.isLive, outputParams.isTrailer);

        const youboraToggle = Utils.getOjectYouboraToggle();
        if (isNPVR && !youboraToggle.npvr) {
            TrackerManager.setup(null, null, null, this.nextContentStreamType);
        }

        if (isReplace && !isLive) {
            TrackerManager.stop(this.getCurrentTime());
        }

        if (
            isLive &&
            outputParams.groupId &&
            TvChannelUtil.getLastChannel() !== outputParams.groupId
        ) {
            console.log('setLastChannel', outputParams.groupId);
            TvChannelUtil.setLastChannel(outputParams.groupId);
            //UpdateMiniObserver se controla ahora en componentWillReceiveProps de Nuevos PlayerControls
            //   UpdateMiniObserver.fire();
        }
        const isAudioSource =
            this.props &&
            this.props.player &&
            this.props.player.source &&
            this.props.player.source.hasOwnProperty('audiosource')
                ? true
                : false;
        if (isLive && !isAudioSource) {
            if (
                this.useChannelRatingFlow() &&
                !AAF.Pin.usePinRequest() &&
                inputParams.source &&
                inputParams.source.videoid
            ) {
                // Verificar si este canal pasó por pin, si es así, "marcarlo" para que el
                // tiemout del statuscontrol pin no lo vuelva a pedir
                if (this.isLivePinBlocked(inputParams.source.videoid)) {
                    this.alreadyEnterLivePin.push(inputParams.source.videoid);
                } else {
                    this.alreadyEnterLivePin = [];
                }
            }
        } else {
            this.deviceAttachAlreadyResponsed = true;
        }
        console.log('[AAF Quick] onResolveParams', new Date() - window.startTime);
        console.log('[AAFPlayer] onResolveParams params ready', outputParams);
        console.log('[AAFPlayer] onResolveParams input params ready', inputParams);

        // Ya que resolvió, play al content, pip o full
        if (!inputParams.isNextSong) {
            //Si es un cambio de canción, no se relanza el mostrar el player, porque en caso de que ya esté mostrado es innecesaria la petición
            //En caso de que no esté, quiere decir que está reproduciendo canción en segundo plano, por lo que no se relanza el Player a pantalla completa
            this.checkToCloseChangingEpisodeModal();
            LayersControl.showPlayer();
        }
        if (this.isPlayerFull && outputParams.groupId && isLive) {
            // Si viene desde una ficha EPG, entonces se inicializa la barra de progreso al timeshift que se vaya a hacer
            if (
                inputParams.starttime !== null &&
                inputParams.timeshiftData &&
                Utils.isNotNullOrNotUndefined(inputParams.timeshiftData.startprogressbar)
            ) {
                this.onUpdateEpg(outputParams.groupId, false, inputParams.timeshiftData);
            } else {
                this.onUpdateEpg(outputParams.groupId);
                // Si no timeshift pero es live, verificar si se requiere hacer la llamada de getmedia asíncrona
                if (
                    outputParams.playerMedia &&
                    outputParams.playerMedia.media &&
                    outputParams.playerMedia.media.epgurlresolved
                ) {
                    // Llamar asíncrono a getmedia para el tracker
                    // En getMediaTask se hace el setup del tracker y se manda la llamada a tracker.getmedia
                    const showErrorModal = true;
                    let payway_token = this.playerStreamingUtils.getPaywayToken(
                        outputParams.groupId,
                        outputParams.isFallback
                    );
                    payway_token = Utils.isNotNullOrNotUndefined(payway_token)
                        ? payway_token
                        : null;

                    // El result de este request a get media (fast play) se captura en el Emitter definido didMount
                    if (!outputParams.isTPA) api.playerGetMedia(
                        outputParams.playerMedia.media.groupId,
                        null,
                        false,
                        outputParams.playerMedia.media.streamType,
                        '',
                        '',
                        payway_token,
                        showErrorModal,
                        { ...outputParams }
                    );
                }
            }

            // Si full, si live, si video, actualizar ruta actual para indicar que aquí se lanzó playing
            this.props.setAafLiveHistory(inputParams);
        } else {
            // Set channel info por el momento sólo se usa para playercontrols legacy
            if (!newPC && this.refs.playerControls) {
                this.refs.playerControls.setChannelInfo({});
            }
        }
        if (
            outputParams &&
            outputParams.playerMedia &&
            outputParams.playerMedia.group &&
            outputParams.playerMedia.group.common &&
            outputParams.playerMedia.group.common.extendedcommon &&
            outputParams.playerMedia.group.common.extendedcommon.media
        ) {
            if (
                newPC &&
                this.refs.nplayerControls &&
                this.refs.nplayerControls.refs &&
                this.refs.nplayerControls.setContentTitle
            ) {
                const {
                    group: {
                        common: {
                            title = '',
                            description = '',
                            duration = '',
                            extendedcommon = {},
                        } = {},
                    } = {},
                } = outputParams.playerMedia;
                const { media = {} } = extendedcommon;
                const {
                    serie: { title: serieTitle = '' } = {},
                    episode: { number = null, season = null } = {},
                } = media;

                let contentTitleHtml,
                    contentTitleNormal = '';
                let contentSerieEpisodeTitle = null;
                if (serieTitle) {
                    const { player: { ispreview } = {} } = this.props;
                    const titleTrailer = `<b>${serieTitle}</b>`;
                    const seasonAbr = Translator.get(
                        'playing_playerControls_abbreviationSeason_label',
                        'Temp.'
                    );
                    const dotsAbr = Translator.get(
                        'playing_playerControls_unionTagEpisode_label',
                        ':'
                    );
                    const episodeAbr = Translator.get(
                        'playing_playerControls_abbreviationEpisode_label',
                        'Ep.'
                    );
                    contentTitleHtml = ispreview
                        ? titleTrailer
                        : `<b>${serieTitle}</b> ${seasonAbr} ${season} | ${episodeAbr} ${number}${dotsAbr} <b>${title}</b>`;
                    contentTitleNormal = `${serieTitle}`;
                    contentSerieEpisodeTitle = `${seasonAbr} ${season} | ${episodeAbr} ${number}${dotsAbr} ${title}`;
                } else {
                    contentTitleHtml = `<b>${title}</b>`;
                    contentTitleNormal = title;
                }

                this.refs.nplayerControls.setContentTitle({
                    title: contentTitleHtml,
                    contentTitleNormal,
                    contentSerieEpisodeTitle,
                    description,
                    duration,
                    group_id: outputParams.groupId,
                });
            }

            if (outputParams.playerMedia.group.common.extendedcommon.media.serie) {
                api.contentSerie(outputParams.groupId).then(this.afterGetDataSe);
            } else {
                if (
                    !newPC &&
                    this.refs.playerControls &&
                    this.refs.playerControls.refs &&
                    this.refs.playerControls.refs.seasons &&
                    this.refs.playerControls.refs.seasons.style &&
                    !Utils.isNullOrUndefined(this.refs.playerControls.refs.seasons.style.display)
                )
                    this.refs.playerControls.refs.seasons.style.display = 'none';
            }
        }

        if (window.performance) {
            if (window.INICIOPLAYUPDOWN) {
                let entB = window.performance.now();
                console.log(
                    '[TIMEMARK] INICIOPLAY UPDOWN TIME>>>>>>>>>>: ' +
                        (entB - window.INICIOPLAYUPDOWN) +
                        'ms'
                );
            }

            if (window.INICIOPLAYBOTONPREV) {
                let entD = window.performance.now();
                console.log(
                    '[TIMEMARK] INICIOPLAY PREV TIME>>>>>>>>>>: ' +
                        (entD - window.INICIOPLAYBOTONPREV) +
                        'ms'
                );
            }
        }

        if (!outputParams.isTPA) AAFPlayer.play(outputParams.ispip);

        FallbackUtil.clearFallback();

        const { streamContentType = null } = outputParams;
        const with_fallback =
            streamContentType !== AAF_CONTENT_IS_AUDIO &&
            streamContentType !== AAF_CONTENT_IS_RADIO;
        // ahora todo se va sobre 15 segs, fallback
        if (with_fallback) {
            if (!outputParams.isTPA) FallbackUtil.setFallbackTimeout(outputParams);
        }
        /**
         * Aquí se manda a llamar el onchanging channel a false
         * Para que no se rompa player controls
         */
        if(outputParams.isTPA) {
            this.onChangingChannel(false);
        }

        if (newPC) {
            let event = null;
            if (streamContentType === AAF_CONTENT_IS_CATCHUP) {
                event = inputParams.event || null;
                this.eventFullEpg = event;
                if (outputParams && outputParams.groupId) {
                    TvChannelUtil.setLastChannel(outputParams.groupId);
                    //UpdateMiniObserver se controla ahora en componentWillReceiveProps de Nuevos PlayerControls
                    //   UpdateMiniObserver.fire();
                }
            }
            if (streamContentType === AAF_CONTENT_IS_NPVR) {
                event = inputParams.npvrEvent || null;
            }

            if (this.refs.nplayerControls) {
                this.refs.nplayerControls.setTimeshiftEventInfo({ event });
            }
        }

        if (this.refs.playerControls && !isLive) {
            this.refs.playerControls.show();
        }
        if (outputParams.isPip) {
            this.AAFResolvedParamsPip = outputParams;
        } else {
            this.AAFResolvedParams = outputParams;
        }

        if (this.isPlayerFull) {
            // En VOD/Live, poner el local time a 0 para que si hay algo en los subtitles,
            // no se muestren antes de tiempo o no se queden "pegados" subs anteriores
            if (Utils.streamIsVideo(outputParams.streamType)) {
                this.setCurrentTime(0, 0);
            }
            // Hay parámetros iniciales de audio y subtitle para reproducir?
            if (outputParams.audiosubtitleinfo) {
                // audio
                if (outputParams.audiosubtitleinfo.audio) {
                    if (
                        MultipleLangLive.isEnabled() &&
                        (isLive || outputParams.streamContentType === AAF_CONTENT_IS_CATCHUP)
                    ) {
                        //Se agrega función para cambiar idioma/subtítulos en LIVE
                        console.log(
                            '[MA-LIVE]-Hay parámetros iniciales de audio y subtitle para reproducir '
                        );
                        console.log(
                            '[MA-LIVE]-outputParams.audiosubtitleinfo.audio=>' +
                                outputParams.audiosubtitleinfo.audio
                        );
                        console.log(
                            '[MA-LIVE]-outputParams.audiosubtitleinfo.subtitle=>' +
                                outputParams.audiosubtitleinfo.subtitle
                        );
                        if (outputParams.audiosubtitleinfo.audio) {
                            const audio = outputParams.audiosubtitleinfo.audio;
                            const subtitle = outputParams.audiosubtitleinfo.subtitle;
                            this.currentLanguageOptionIDSubtitle = subtitle;
                            if (
                                MultipleLangLive.isGroupIdEnabled(
                                    outputParams.groupId,
                                    outputParams.streamType
                                )
                            ) {
                                this.setAudioTrackLive(audio, subtitle);
                            }
                        }
                    } else {
                        if (this.platform !== 'workstation') {
                            this.setAudioTrack(outputParams.audiosubtitleinfo.audio);
                        }
                    }
                }
                // subtitle externo
                if (
                    MultipleLangLive.isEnabled() &&
                    (isLive || outputParams.streamContentType === AAF_CONTENT_IS_CATCHUP)
                ) {
                    if (!outputParams.audiosubtitleinfo.subtitle) {
                        this.resetSubtitlesParser();
                    }
                } else {
                    if (outputParams.audiosubtitleinfo.subtitle) {
                        this.handleSubtitlesParser(outputParams.audiosubtitleinfo.subtitle);
                    } else {
                        // Si hay alguno, kill subtitle anterior
                        this.resetSubtitlesParser();
                    }
                }
            }

            // TODO AAFPlayer agregar el optionId a nivel de este componente para
            // llevar un control del lang que esta viendo el user y no cambiar lenguaje a menos que
            // realmente quiera otra opción de lenguaje y no la que esta playeando actualmente
            // seguir usando this.currentLanguageOptionID ?
            if (outputParams.audiosubtitleinfo && outputParams.audiosubtitleinfo.optionId) {
                this.currentLanguageOptionID = outputParams.audiosubtitleinfo.optionId;
            }

            // AAFPlayer set multiple y single-combo de opciones de lenguage

            //if(!outputParams.isLive) {
            //if(!params.isLive) {
            // Para single/múltiple (combo de langs)
            this.langOptions = outputParams.extendedCommonLangOptions;
            // Para múltiple

            this.multipleLangOptions = outputParams.multipleLangOptions;
            if (
                MultipleLangLive.isEnabled() &&
                (isLive || outputParams.streamContentType === AAF_CONTENT_IS_CATCHUP)
            ) {
                if (
                    outputParams &&
                    outputParams.extendedCommonLangOptions &&
                    typeof outputParams.extendedCommonLangOptions == 'object'
                ) {
                    const LangOptions = MultipleLangLive.createOptionsModal(
                        outputParams.extendedCommonLangOptions
                    );
                    this.onUpdateLangOptions(LangOptions);
                }
            } else {
                if (Array.isArray(outputParams.extendedCommonLangOptions)) {
                    const wasResume = !isNaN(outputParams.resume)
                        ? parseInt(outputParams.resume)
                        : 0;
                    const firstLang = outputParams.extendedCommonLangOptions[0]
                        ? outputParams.extendedCommonLangOptions[0]
                        : null;

                    let isResumeAfterIntro = false;
                    if (firstLang && wasResume > 0) {
                        const introFinishTime = firstLang.intro_finish_time
                            ? parseInt(firstLang.intro_finish_time)
                            : 0;
                        isResumeAfterIntro = wasResume > introFinishTime - 2;
                    }

                    this.onUpdateLangOptions(
                        outputParams.extendedCommonLangOptions,
                        isResumeAfterIntro,
                        wasResume
                    );
                }

                this.onUpdateSprite(outputParams);
            }

            //}

            /*
       TODO AAFPlayer, echar a andar los video live languages, como en el caso de nagra e iwedia
       // HARDCODED Only for nagra live DVBC ****************
       if(this.isPlayerFull && this.platform === 'nagra' && nextPlayerProps.streamType === playerConstant.DVBC && nextPlayerProps.isLive) {
       this.setNagraLiveLang();
       }
       */

            //TODO AAFPlayer para música, checar este dispatch (antes se hacía en el middleware)
            if (outputParams.streamType === 'audio') {
                store.dispatch(configSetupPlay());
            }

            // Si es live y haay que hacer el primer seek del timeshift, entons hacerlo aquí
            if (inputParams.starttime !== null && inputParams.timeshiftData) {
                if (!EventTimeshift.isEnabled()) {
                    this.setTimeshiftSeek(inputParams.timeshiftData, true);
                }
            }
            if (streamContentType === AAF_CONTENT_IS_AUDIO) {
                const audioTracking = store.getState().playermusica;
                const { currentContent: { tracking = {}, durationInSeconds = 0 } = {} } =
                    audioTracking;
                /*
        error:
        url: "http://localhost:5000/middleware/tracking/error?playlist=11638529&track=74757898"
        __proto__: Object
        success:
        body: {device: {…}}
        data: {phonograms: {…}}
        url: "http://localhost:5000/middleware/tracking/success?playlist=11638529&track=74757898"
        __proto__: Object
        tick:
        interval_timer: 20
        url: "http://localh*/
                // TODO verificar trackId del AAFPlayer vs currentContent en redux store?
                if (tracking && (tracking.error || tracking.success || tracking.tick)) {
                    const config = getAppConfig();
                    inputParams.audioTracking = tracking;
                    // Genear objeto para el replace
                    const audioData = {
                        // success.body.device
                        device_model: config.device_model,
                        os_version: config.device_so,
                        // success.data.phonograms
                        duration: '@duration',
                        net_type: 1,
                        is_starter: 1,
                        audioDurationInSeconds: durationInSeconds,
                    };
                    inputParams.requestData = audioData;
                }
                EventEmitter.emit('player:setupTracker', { isVideo: false, data: inputParams });
            }

            this.setState({ enableplayercontrols: true });
        }
    }

    async onResolveAsyncPinFailed(failNextOptions) {
        let replaceGid = null;
        let _replaceGid = null;
        if (failNextOptions && failNextOptions.source && failNextOptions.source.videoid) {
            _replaceGid = failNextOptions.source.videoid;
        }

        if (_replaceGid) {
            replaceGid = await AAF.Pin.getChannelOption(_replaceGid);
        }

        if (replaceGid) {
            store.dispatch(
                playFullMedia({
                    playerstate: 'PLAYING',
                    source: {
                        videoid: replaceGid,
                    },
                    size: {
                        top: 0,
                        left: 0,
                        width: 1280,
                        height: 720,
                    },
                    ispreview: false,
                    islive: true,
                    ispip: false,
                    event: null,
                })
            );
        } else {
            let nullPlayer = {
                ispip: false,
                islive: true,
                playerstate: 'STOPPING',
                event: null,
            };
            store.dispatch(playFullMedia(nullPlayer));
            LayersControl.showUX();
        }
    }

    // AAFPlayer pide input del user o muestra error
    onResolveShowModal(params) {
        if (!this.isPlayerFull) return;
        AAFPlayer.setTryingToPlayOptions(null);
        const devicesExceededError = this.findDevicesExceededError(params);
        if (devicesExceededError) {
            params.errorCode = devicesExceededError;
            return this.handleModalDevicesExceeded(params);
        }
        switch (params.modalType) {
            // Parental
            case MODAL_PIN:
                this.handleModalParental(params);
                break;
            // PGM error
            case MODAL_REINTENTO:
                this.handleModalReintentoError(params.modalMessage, params.nextOptions, params);
                break;
            // Bookmark
            case AAF_MODAL_PLAY_OPTIONS:
                this.handleModalBookmark(params);
                break;
            // Error,
            case AAF_MODAL_ERROR:
                this.handleCantPlay(params);
                break;
            case MODAL_END_PLAYER:
            case MODAL_END_PLAYER2:
                store.getState().modal.modalType !== MODAL_KEEP_WATCHING && this.modalEndPlayer()
                break;
        }
        console.log('Resolve onShowModal Resolve params ready', params);
    }

    modalEndPlayer() {
        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: modalEndPlayer'}`);

        let next = null;
        let background = null;
        let _title = '';
        const { enable, totalTimePlayer, episodesCount, totalEpisodes } = store.getState().modalInactivity;


        if (
            this.AAFResolvedParams.playerMedia.next_group &&
            this.AAFResolvedParams.playerMedia.next_group.common
        ) {
            next = this.AAFResolvedParams.playerMedia.next_group.common;
        }

        if (
            this.AAFResolvedParams.playerMedia.group &&
            this.AAFResolvedParams.playerMedia.group.common
        ) {
            if (this.AAFResolvedParams.playerMedia.group.common.image_background) {
                background = this.AAFResolvedParams.playerMedia.group.common.image_background;
            }
            if (this.AAFResolvedParams.playerMedia.group.common.title) {
                _title = this.AAFResolvedParams.playerMedia.group.common.title;
            }
        }

        const {
            group: {
                common: {
                    extendedcommon: { media: { serie: { title = null } = {} } = {} } = {},
                } = {},
            } = {},
        } = this.AAFResolvedParams.playerMedia;

        this.episodeCount = this.episodeCount + 1
      const checkTimeAndEpisodes = episodesCount > totalEpisodes
      if(enable && checkTimeAndEpisodes) {
        this.episodeCount = 0
        AAFPlayer.pause();
        const exit = () => {
          const nextGid = {
            ispip: false,
            islive: false,
            ispreview: false,
            resume: 0,
            playerstate: 'STOPPING',
            event: null
          };
          store.dispatch(playFullMedia(nextGid));
          handleRedirectModalInactivity(()=>{}, this.props.history, "return")
          this.closeModal();
          PlayerControlsLogic.resetDataModalSleep();
          LayersControl.showUX()
        };
        const play = () =>{
          const payway_token = this.PBIEpisodeNext && this.PBIEpisodeNext.playButton && this.PBIEpisodeNext.playButton.payway_token;
          next ? modalInactivityPlayVODSeries(next, title, payway_token) : exit()
        }

        PlayerControlsLogic.showModalSleep({ play, exit });
      } else {
          modalInactivityStartVODSeries(this.episodeCount);
          const modal = {
            modalType: this.platform === 'arris' ? MODAL_END_PLAYER : MODAL_END_PLAYER2,
            modalProps: {
                next,
                title: _title,
                background,
                serieData: this.serieData,
                recommendations: this.AAFResolvedParams.recommendations
                    ? this.AAFResolvedParams.recommendations
                    : [],
                serieTitle: title,
                user: this.props.user,
                showModal,
                closeModal: this.closeModal,
                history: this.props.history,
                duration: this.getDuration(),
                currentTime: this.getCurrentTime(),
                PBIEpisodeNext: this.PBIEpisodeNext,
                playNextEpisodeWhenEndPlayerClosed: this.playNextEpisodeWhenEndPlayerClosed,
                idCardSrach: this.props && this.props.player && this.props.player.source ? this.props.player.source.videoid : null,
            }
          };
          store.dispatch(showModal(modal));
          if(!next) {
            this.episodeCount = 0;
          }
      }
    }

    playNextEpisodeWhenEndPlayerClosed(next, PBIEpisodeNext) {
        if(!next) {
            this.nextEpisodeToPlay = null;
            return;
        }

        this.nextEpisodeToPlay = null;

        if(PBIEpisodeNext) {
            if(PBIEpisodeNext && PBIEpisodeNext.playButton && PBIEpisodeNext.playButton.waspurchased) {
                this.nextEpisodeToPlay = next;
            }
        }
        else {
            api.PurchaseButtonInfov585({groupId: next.id}).then(
                (pbi) => {
                    const wasPurchased = pbi && pbi.playButton && pbi.playButton.waspurchased;
                    if (wasPurchased) {
                        this.nextEpisodeToPlay = next;
                    }
                }
            ).catch(
                (err) => {
                    this.nextEpisodeToPlay = null;
                }
            );
        }
    }

    async modalEndPlayerCatchup() {
        const groupId = this.AAFResolvedParams.groupId;
        const currentEvent = this.getCurrentEvent();
        const liveEvent = await EPGUtil.getCurrentEventByGroupId(groupId);
        const nextEvent = await EPGUtil.getNextEventByEvent(currentEvent);
        const nextEventOptions = {
            playerstate: 'PLAYING',
            source: {
                videoid: groupId,
            },
            size: {
                top: 0,
                left: 0,
                width: 1280,
                height: 720,
            },
            ispreview: false,
            islive: false,
            ispip: false,
            starttime: nextEvent.date_begin,
            endtime: nextEvent.date_end,
            event: nextEvent,
        };

        const liveEventOptions = {
            playerstate: 'PLAYING',
            source: {
                videoid: groupId,
            },
            size: {
                top: 0,
                left: 0,
                width: 1280,
                height: 720,
            },
            ispreview: false,
            islive: true,
            ispip: false,
            starttime: null,
        };

        const buttons = [];
        // Next event button
        if (liveEvent.id !== nextEvent.id) {
            buttons.push({
                props: {
                    onClick: () => store.dispatch(playFullMedia(nextEventOptions)),
                    className: "aaf-modal-button-primary"
                },
                content: Translator.get("playing_modal_option_button_nextEvent", "VER SIGUIENTE")
            })
        }
        // Live event button
        buttons.push({
            props: {
                onClick: () => store.dispatch(playFullMedia(liveEventOptions)),
                className: "aaf-modal-button-primary"
            },
            content: Translator.get("playing_modal_option_button_liveEvent", "IR A EN VIVO")
        })

        const modal = {
            modalType: MODAL_END_PLAYER_CATCHUP,
            modalProps: {
                title: Translator.get("playing_modal_secondsToStart_label", "Continúa viendo en @seconds segundos"),
                withCancel: false,
                aafNewStyle: true,
                buttonsAlign: "vertical",
                showLogo: false,
                buttons,
                ms: 1000,
                countdown: 10,
                callbackWhenBack: () => this.goBack(true),
            },
        };

        store.dispatch(showModal(modal));
    }

    /**
     * Errores de resolución de qué playear desde AAFPlayer deberían caer aquí
     * Aquí NO caen errores de PGM, porque en este punto ni siquiera pudo resolver pgm
     * @param {*} params es un AAFException:
     *                   name = "AAFResolveException";
     *                   type = constant onResolvePlayingError;
     *                   message = message;
     *                   data = data; en data vienen las nextOptions con las que se intentó playear
     */
    onResolveError(params) {
        if (!this.isPlayerFull) return;
        let isStartPlayFalled = false;
        if (params.data && params.data.startPlayFalled) {
            TrackerManager.startPlayFalled();
            params.data.deleteLastStream = null;
            delete params.data.streamContentType;
            delete params.data.supported_stream_types;
            delete params.data.startPlayFalled;
            isStartPlayFalled = true;
        }
        this.handleModalReintentoError(params.message, params.data, params, isStartPlayFalled);
    }

    findDevicesExceededError(params) {
        if (params && params.pgm) {
            const error = this.getPLYErrorFromPGM(params.pgm);
            if (error && error.code) {
                return error.code;
            }
        }
        return null;
    }

    getPLYErrorFromPGM(pgm) {
        const { errors = [] } = pgm || {};
        return errors.find((error) => error && error.code === ERROR_CODE_DEVICES_EXCEEDED);
    }

    handleModalDevicesExceeded(params) {
        const replayOptions = params.nextOptions;
        replayOptions.isretry = !replayOptions.isretry;
        const errorCode = params.errorCode;
        if (!this.isPlayerFull) return;
        const modal = {
            modalType: MODAL_DEVICES_EXCEEDED,
            modalProps: {
                errorCode,
                onReject: () => {
                    this.clearLoading();
                },
                onRetry: () => {
                    this.closeModal();
                    AAFPlayer.setPlayerState(
                        replayOptions,
                        this.getAAFPlayerWrapper(),
                        this.getAAFCallbacks()
                    );
                },
            },
        };
        store.dispatch(showModal(modal));
    }

    handleModalReintentoError(message, replayOptions, params, isStartPlayFalled = false) {
        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: handleModalReintentoError'} ${'Message: '+ message }`);

        if (!this.isPlayerFull) return;
        const { pgm = {} } = params || {};
        if (!Utils.showModalError(true, pgm)) {
            this.clearLoading();
            return;
        }

        const modal = {
            modalType: MODAL_REINTENTO,
            modalProps: {
                onReject: () => {
                    console.log('Modal error');
                    this.clearLoading();
                },
                onRetry: () => {
                    AAFPlayer.setPlayerState(
                        replayOptions,
                        this.getAAFPlayerWrapper(),
                        this.getAAFCallbacks()
                    );
                },
                messageModal: message,
                // Si se quiere incorporar la nueva modal (con un solo botón) para otros errores,
                // se debe pasar el parámetro errorCode (se podría tomar desde pgm.errors[0].code)
                errorCode: isStartPlayFalled ? 'api_error' : null,
                isStartPlayFalled,
                retryPlaying: params,
                clearLoading: () => {
                    this.clearLoading();
                },
            },
        };
        store.dispatch(showModal(modal));
    }

    /**
     * params es from AAF
     */
    handleModalParentalStep(currentPin, pinIsCreated, params) {
        if (!this.isPlayerFull) return;

        console.log('[ERRR] 1');
        if (pinIsCreated) {
            // Cerrar modal
            store.dispatch({
                type: HIDE_MODAL,
                modalType: MODAL_PIN,
            });
        }
        params.successCallBack(params.nextOptions, params.isSourceReplace);
    }

    /*
     *
     */

    restartMiniEPG() {
        let currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions(false);
        let currentChannelPlaying =
            currentPlayerOptions &&
            currentPlayerOptions.source &&
            currentPlayerOptions.source.videoid
                ? currentPlayerOptions.source.videoid
                : false;
        if (currentChannelPlaying && !AAFPlayer.livePlayingAsPip()) {
            this.changeChannel(currentChannelPlaying, true, currentPlayerOptions); // Esto se hace para recuperar el estado anterior de la miniEPG
            if (this.state.showMiniEpg !== false) {
                this.setState({ showMiniEpg: false }); //Se oculta para evitar que el usuario note el cambio repentino en la mini
            }
        }
    }

    handleModalParental(params) {
        const gid = params.gid ? params.gid : '-';
        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: handleModalParental'} ${'Message: Muestra moda de pin' + gid }`);

        console.log('[ERRR] 1');
        if (!this.isPlayerFull) return;
        this.handleModalParentalStep = this.handleModalParentalStep.bind(this);

        // Si viene de un async pin se rompe el fallback!!
        if (Utils.isNotNullOrNotUndefined(params.useAsyncPin) && params.useAsyncPin === true) {
            FallbackUtil.clearFallback();
        }

        console.log('[ERRR] 2');

        const typeReproduction = params.nextOptions.streamContentType;
        const validateTypeForTypeReproduction = typeReproduction === TYPE_OF_REPRODUCTION
        ? 'MODAL_PIN_CODE_RATING_TYPE'
        : 'MODAL_PIN_CODE_CHANNEL_TYPE';

        const { isFlowSearcherForPin = false } = store.getState().searcher;

        const validateTypeModalPin = isFlowSearcherForPin
        ? MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER : validateTypeForTypeReproduction

        const modal = {
            modalType: MODAL_PIN,
            modalProps: {
                type: validateTypeModalPin,
                action: 'MP_CHECAR_STATUS',
                pinIsCreated: true,
                // En caso de que ch up down respondan en modal pin
                // handleCloseWithChUpDown: () => {
                //   const modalHide = {
                //     modalType: HIDE_MODAL,
                //     modalProps: {}
                //   }
                //   store.dispatch(showModal(modalHide));
                //   this.clearLoading();
                // },
                successCallBack: (currentPin, contentwithbookmark) => {
                    NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: handleModalParental - successCallBack'} ${'Message: Muestra moda de pin es exitoso'}`);
                    this.handleModalParentalStep(currentPin, contentwithbookmark, params);
                },
                cancelCallBack: () => {
                    NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: handleModalParental - cancelCallBack'} ${'Message: Muestra moda de pin no es exitoso'}`);
                    if (
                        Utils.isNotNullOrNotUndefined(params.useAsyncPin) &&
                        params.useAsyncPin === true
                    ) {
                        if (params.failedCallBack) {
                            params.failedCallBack();
                        }
                    } else {
                        if (
                            (this.isFirstTimeShowModalPin && !this.alreadyPlayChannel) ||
                            !params.nextOptions.islive
                        ) {
                            LayersControl.showUX();
                            this.isFirstTimeShowModalPin = false;
                        }
                        this.onChangingChannel(false);
                        if (params.failedCallBack) {
                            params.failedCallBack();
                        }
                        if (params.nextOptions && params.nextOptions.islive) {
                            this.restartMiniEPG();
                        }
                    }
                    UtilsSearch.updateDataStoreFlowFuture({isFuture: false, itemChick: {}})
                    UtilsSearch.updateDataStoreSearcher({isFlowSearcherForPin: false});

                },
            },
        };

        store.dispatch(showModal(modal));

        asyncPinObserver.subscribe(UtilsSearch.flowFutureSearcherShowOptions)
    }

    /**
     * params es from AAF
     */
    handleModalBookmark(params) {
        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: handleModalBookmark'}`);

        if (!this.isPlayerFull) return;
        const buttons = [
            {
                content: Translator.get('player_continue_btn', 'Reanudar'),
                extraClass: 'btn-modal-bookmark bookmark_continue',
                props: {
                    onClick: (e) => {
                        // Desde AAFPlayer, de regreso: resetBookmark, nextOptions, isSourceReplac
                        params.successCallBack(false, params.nextOptions, params.isSourceReplace);
                    },
                    variant: 'dark',
                },
            },
            {
                content: Translator.get('player_begin_btn', 'Desde el principio'),
                extraClass: 'btn-modal-bookmark bookmark_begin',
                props: {
                    onClick: (e) => {
                        // Desde AAFPlayer, de regreso: resetBookmark, nextOptions, isSourceReplac
                        params.successCallBack(true, params.nextOptions, params.isSourceReplace);
                    },
                    variant: 'dark',
                },
            },
        ];

        const modal = {
            modalType: AAF_MODAL_PLAY_OPTIONS,
            modalProps: {
                buttons,
            },
        };

        store.dispatch(showModal(modal));
    }

    handleCantPlay(modalParams) {
        if (!this.isPlayerFull) return;
        NewRelic.actionText(`${'LogType: Newrelic File: Video/index.js'} ${'Method: handleCantPlay'} ${'Message: '+  modalParams.modalMessage}`);
        const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                callback: modalParams.callback,
                content: { code: modalParams && modalParams.content && modalParams.content.code ? modalParams.content.code : null, message: modalParams.modalMessage },
            },
        };

        store.dispatch(showModal(modal));
    }

    getSafeTime() {
        const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

        if (timeshiftMetadata) {
            return timeshiftMetadata.start;
        } else {
            return 0;
        }
    }

    // END ================================================================================================================================================

    fillFullChannels(data) {
        this.channelsCoverFLow(data);
        this.channelJSON = data.map((x, index) => {
            return x.group_id;
        });

        if (this.linealChannels) {
            let paywayIds = this.props.linealChannels.map((x) => x.id);
            this.channelJSONPurchased = this.channelJSON.filter((x) => paywayIds.indexOf(x) > -1);
        }
    }

    setNagraLiveLang() {
        if (!this.isPlayerFull) return;
        // get live dvbc langs
        this.player.getAudioTracks().then(() => {
            console.log(
                '[Video component] resp getAudioTracks en video component: ',
                this.player.audioTracks
            );

            let i;
            let newOptions = [];
            if (Utils.isArray(this.player.audioTracks) && this.player.audioTracks.length > 0) {
                for (i = 0; i < this.player.audioTracks.length; i++) {
                    let label_lang = 'Unknow';
                    let option_lang = '';
                    //info.streamsAvailableInfo.streamInfo[i].iaudio.language
                    if (this.player.audioTracks[i].iaudio.language === 'spa') {
                        label_lang = 'Español';
                        option_lang = 'D-ES';
                        if (this.player.audioTracks[i].isDefault === true) {
                            console.log('[Video component] before setSelectedLanguage spanish');
                            this.setSelectedLanguage(option_lang);
                        }
                    }
                    if (this.player.audioTracks[i].iaudio.language === 'eng') {
                        label_lang = 'Inglés';
                        option_lang = 'D-EN';
                        if (this.player.audioTracks[i].isDefault === true) {
                            console.log('[Video component] before setSelectedLanguage english');
                            this.setSelectedLanguage(option_lang);
                        }
                    }

                    let a_option = {
                        label_short: label_lang,
                        label_large: label_lang,
                        option_lang: option_lang,
                        option_name: label_lang,
                        encodes: [],
                        id: '',
                        id_lang: this.player.audioTracks[i].iaudio.language,
                        desc: label_lang,
                    };

                    newOptions.push(a_option);
                }
            }
            // Re fill combo for languages
            this.onUpdateLangOptions(newOptions);
        });
    }

    setLoading() {
        if (this.state.loading !== true) {
            console.log('[TPA] Video/Index::setLoading enter, se pone loading spinner');
            this.setState({ loading: true }, () => {
                console.log(
                    '[TPA] Video/Index::setLoading termina el set state del loading spinner'
                );
            });
        }
    }

    /**
     * Es probable que este metodo se ejecute dos veces en STB/android, una desde el observer del player android y otra desde el onload event del player android
     * Pero en tanto android no nos envíe un evento confiable de cuando ya está reproduciendo, se quedan las dos :/
     * El setState sólo aplica cuando el spinner aún este en pantalla así que performance no debe afectar, el onchangingchannel sólo es cambio de valor en una bandera
     *
     * En smartTV sólo se debe ejecutar una vez, porque en smartTV no existe el observer
     */
    clearLoading() {
        console.log('[TPA] Video/Index::clearLoading enter');
        console.log('[TPA] Video/Index::clearLoading this.state.loading', this.state.loading);
        this.onChangingChannel(false);
        if (this.state.loading !== false) {
            this.setState({ loading: false }, () => {
                console.log(
                    '[TPA] Video/Index::clearLoading, se hizo el setState del clear loading'
                );
            });
        }
    }

    hide() {
        console.log('[Video component] HIDE VIDEO COMPONENT');
        if (this.state.extraClass.indexOf(' hide') == -1) {
            this.setState({ extraClass: this.state.extraClass + ' hide' });
        }
    }

    show() {
        this.setState({ extraClass: this.state.extraClass.replace(' hide', '') });
    }

    async record(event) {
        if (!NpvrUtil.viewButtonRecording({ event })) {
            this._showPlayerEventRecordingNotAvailableNotification();
            return;
        }

        const groupId = event.groupId || event.group_id;
        const notificationProps = {
            show: true,
            title: Translator.get('recording_already_started', '¡Grabando!'),
            msg: Translator.get(
                'recording_already_notification_started',
                'Este programa ya fue agregado a tu sección de Mis grabaciones'
            ),
            apaAsset: 'player_controls_recording_icon',
            type: 'message',
        };
        if (ChannelSingleton.getNpvrStorage(groupId) === 0) {
            notificationProps.msg = Translator.get(
                'recording_forbidden',
                'El programa que quieres grabar no tiene permisos'
            );
            notificationProps.title = Translator.get(
                'recording_error',
                '¡Error al intentar grabar!'
            );
            return store.dispatch(showNotification(notificationProps));
        }
        notificationProps.msg = 'El programa ya se encuentra grabandose :|';

        if (NpvrUtil.recordingIconEnable().enable) {
            // SE AGREGA LOGICA DE SERIES
            let currentContentStreamType = this.getCurrentStreamContentType();
            // SE ABRE MODAL DE OPCIONES
            ModalEpgUtils.blueHandler({
                hideEpgOutsideCb: this.hideEpgOutside,
                handleGuideCb: null,
                data: event,
                streamType: this.AAFResolvedParams && this.AAFResolvedParams.streamType,
                streamContentType: currentContentStreamType,
                changeLangCb: this.changeLang,
            });
        }
    }

    handleEpg(par, filterTV = null) {
        // Se cierra o se abre la full epg?
        // Si esta en true, esta en abierta, se va a cerrar...
        //        let goingToHide = this.state.showEpg === true;
        let nextState = { showEpg: !this.state.showEpg };

        if (par) {
            nextState.epgType = par;
        } else {
            nextState.receiveOK = false;
        }
        nextState.filterEpg = filterTV;

        if (Utils.getIsFromSearch()) {
            nextState.showEpg = true;
            nextState.showMiniEpg = false;
            Utils.setIsFromSearch(false);
        }

        this.setState(nextState);
    }

    getEpgType() {
        return this.state.epgType;
    }

    setEpgType(epgType) {
        this.setState({ epgType });
    }

    hasEpgError() {
        return this.state.hasEpgError;
    }

    setEpgError(hasEpgError) {
        this.setState({ hasEpgError });
    }
    /*
   launchCoverFlow(value) {
   //this.setState({ showCoverFlow: value})
   }
   */

    /**
     * from = desde dónde viene el play, hasta este momento sólo se usa en el mosaico de la EPG
     */
    hideEpgOutside(withGPChange = null, channel, playFrom = null) {
        if (window.performance)
            console.log('[TIMEMARK] entro a hideEpgOutside: ' + window.performance.now());

        //console.log('[dann][Video Component] hideEpgOutside',withGPChange);

        let nextState = {};

        if (this.state.receiveOK !== true) {
            //this.setState({ receiveOK: true });
            nextState.receiveOK = true;
        }
        if (this.state.showEpg !== false) {
            // Si ocultamos la full, reset del filter para que restablezca a todos
            //this.setState({ showEpg: false, filterEpg: null });
            nextState.showEpg = false;
        }
        if (this.state.showMiniEpg !== false && !withGPChange) {
            //this.setState({ showMiniEpg: false });
            nextState.showMiniEpg = false;
        }
        if (this.state.coverFlow !== false) {
            //this.setState({ coverFlow: false });
            nextState.coverFlow = false;
        }
        // Reset channel filter
        nextState.filterEpg = null;

        if (withGPChange) {
            if (window.performance)
                console.log(
                    '[TIMEMARK] en hideEpgOutside, enviando changeChannel: ' +
                        window.performance.now()
                );
            this.changeChannel(withGPChange, true, channel, playFrom);
        }
        this.setState(nextState);
    }

    hideOnlyMini(newChannelIndex) {
        FallbackUtil.clearFallback();

        this.setFromProps(true);
        this.changeChannel(newChannelIndex);
        store.dispatch(navigateFrom('ChangeWithNumber'));
    }

    onChangingChannel(status) {
        this.changingChannel = status;
    }

    isChangingChannel() {
        return this.changingChannel;
    }

    showEPG(epgType = 'GUIDE') {
        if (epgType == 'MOSAIC') {
            return;
        }
        this.setState({
            showEpg: true,
            epgType,
        });
    }

    shouldComponentUpdate(newProps, newState) {
        const locationState = (newProps.location && newProps.location.state) || false;
        if (locationState.isLive !== undefined && newProps.player) {
            newProps.player.isLive = locationState.isLive;
        }

        let su =
            JSON.stringify(this.state) !== JSON.stringify(newState) ||
            JSON.stringify(this.props.player) != JSON.stringify(newProps.player);
        //console.log("[Video component] shouldComponentUpdate", su);
        return su;
    }

    handleRedirect(path = '/', state = {}, isReplace = false) {
        /*if (isReplace) {
     console.log('CHOTO 1', path, state);
     this.props.history.replace(path, state);
     } else {
     this.props.history.push(path, state);
     }*/
    }

    /**
     *
     * @param {*} epgGroupId
     * @param {*} fromCoverFlow
     * @param {*} startprogressbar cuando llega aquí desde un clic en ficha de epg-evento pasado, inicializa el progress bar de player controls
     */

    onUpdateEpg(epgGroupId, fromCoverFlow = false, timeshiftData = null) {
        const newPC = this.useNewPlayerControls();
        if (!fromCoverFlow) this.ResolvegroupId = epgGroupId;
        const lastChannel = TvChannelUtil.getLastChannel();
        const newGroupId = lastChannel ? lastChannel : epgGroupId;
        const timeshiftAllowed = ChannelSingleton.getTimeshift(newGroupId, true);
        const startprogressbar = timeshiftData === null ? null : timeshiftData.startprogressbar;

        if (timeshiftData) {
            this.timeShift = timeshiftData;
        }

        const currentTimeshiftTime = this.state.currentTimeshiftTime;
        if (!newPC && this.refs.playerControls) {
            // this.channelInfo es sólo para player controls, no aplica (aún) para epg full (if de abajo)
            //this.channelInfo = { id: epgGroupId, timeshiftAllowed, currentTimeshiftTime, fromCoverFlow, startprogressbar };
            this.channelInfo = {
                id: epgGroupId,
                timeshiftAllowed,
                currentTimeshiftTime,
                fromCoverFlow,
            };
            this.refs.playerControls.setChannelInfo(this.channelInfo);
        }
        if (newPC && this.refs.nplayerControls) {
            // this.channelInfo es sólo para player controls, no aplica (aún) para epg full (if de abajo)
            //this.channelInfo = { id: epgGroupId, timeshiftAllowed, currentTimeshiftTime, fromCoverFlow, startprogressbar };
            this.channelInfo = {
                id: epgGroupId,
                timeshiftAllowed,
                currentTimeshiftTime,
                fromCoverFlow,
            };
            if (this.refs.nplayerControls.setChannelInfo) {
                this.refs.nplayerControls.setChannelInfo(this.channelInfo);
            }
        }
        if (this.refs['epgControls']) {
            this.refs['epgControls']
                .getWrappedInstance()
                .setChannelInfo({ id: epgGroupId, fromCoverFlow }, this.props.player.filterTV);
        }
    }

    sendTPAMetric(TPA, fireTPAFrom) {
        let metricsEvent = {};
        const aLabel =
            TPA && TPA.package && TPA.package.indexOf('netflix') !== -1 ? 'netflix' : 'prime video';
        switch (fireTPAFrom) {
            case LIVE_PLAY_FROM_HOME:
                metricsEvent = {
                    hitType: 'event',
                    eventCategory: 'carruseles inicio',
                    eventAction: 'canales premium',
                    eventLabel: aLabel,
                };
                break;

            case LIVE_PLAY_FROM_MOSAIC:
                metricsEvent = {
                    hitType: 'event',
                    eventCategory: 'guia de programacion',
                    eventAction: 'click',
                    eventLabel: aLabel,
                };
                break;

            default:
            case LIVE_PLAY_FROM_EPG:
                metricsEvent = {
                    hitType: 'event',
                    eventCategory: 'mini guia',
                    eventAction: 'click',
                    eventLabel: aLabel,
                };
                break;
        }

        this.props.setMetricsEvent(metricsEvent);
        this.props.setMetricsEvent({ type: 'executor' });
        this.sendDimension();
    }

    /**
     *
     */
    onFireTPA(TPA, playerOptions) {
        // Se forza el state del loadind spnner
        //TODO Revisar este forzado
        this.setState({ loading: false }, () => {
            const fireTPAFrom = Utils.isNotNullOrNotUndefined(playerOptions.playLiveFrom)
                ? playerOptions.playLiveFrom
                : LIVE_PLAY_FROM_EPG;
            this.sendTPAMetric(TPA, fireTPAFrom);
            // Nota: Se excluye el método showUX para dejar el mismo comportamiento de la aplicación antes de ejecutar la TPA
            // LayersControl.showUX();
            // Hacer redirect al home
            const nav = Utils.getApaMetadataKey(
                'links_nav_configuration',
                Utils.mock_links_nav_configuration()
            );
            if (nav && nav.home) {
                console.log(
                    '[TPA] Video/Index::onFireTPA Se hace redirect a ',
                    `/node/${nav.home}`
                );
                this.props.history.replace(`/node/${nav.home}`);
            }
        });
    }

    onResultFireTPA(TPA, playerOptions, launchResult) {
        if (launchResult) return;

        const aLabel =
            TPA.package && TPA.package.indexOf('netflix') !== -1 ? 'netflix' : 'prime video';
        const metricsEvent = {
            hitType: 'event',
            eventCategory: aLabel,
            eventAction: 'alerta',
            eventLabel: 'usuario sin app',
        };

        this.props.setMetricsEvent(metricsEvent);
        this.props.setMetricsEvent({ type: 'executor' });
        this.sendDimension();
    }

    onTimeshiftEvent(event) {
        this.timeshiftEventInfo = event;
        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.setTimeshiftEventInfo) {
            let currentContentStreamType = this.getCurrentStreamContentType();
            if (
                currentContentStreamType === AAF_CONTENT_IS_NPVR ||
                currentContentStreamType === AAF_CONTENT_IS_CATCHUP
            ) {
                // Para catchup y npvr el event se manda a nuevo playercontrols en el onResolveParams
                return;
            }
            this.refs.nplayerControls.setTimeshiftEventInfo(event);
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.setTimeshiftEventInfo) {
            this.refs.playerControls.setTimeshiftEventInfo(event);
        }
    }

    onSkipToLive(group_id, channel) {
        const newPC = this.useNewPlayerControls();
        if (
            newPC &&
            this.refs.nplayerControls &&
            Utils.isObject(channel) &&
            Utils.isNotNullOrNotUndefined(channel.closePlayerControls) &&
            channel.closePlayerControls === true
        ) {
            this.refs.nplayerControls.hideAll();
        }
        if (
            !newPC &&
            this.refs.playerControls &&
            Utils.isObject(channel) &&
            Utils.isNotNullOrNotUndefined(channel.closePlayerControls) &&
            channel.closePlayerControls === true
        ) {
            this.refs.playerControls.hide();
        }
        this.changeChannel(group_id, true, channel);
    }

    /**
     *
     * @param {*} seekWasTo seconds, the seek we did to
     */
    onSeekStartOver(seekWasTo) {
        // Notifica cuando un seek fue hecho sobre un startOver
        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.onSeekStartOver) {
            this.refs.nplayerControls.onSeekStartOver(seekWasTo);
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.onSeekStartOver) {
            this.refs.playerControls.onSeekStartOver(seekWasTo);
        }
    }

    /**
     *
     * @param {*} params last speed change
     * params = {speed: number, direction: FORWARD|BACKWARD}
     */
    onRateChange(params) {
        // Notifica cuando un seek fue hecho sobre un startOver
        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.onRateChange) {
            this.refs.nplayerControls.onRateChange(
                params.speed,
                params.direction,
                params.frompause
            );
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.onRateChange) {
            this.refs.playerControls.onRateChange(params.speed, params.direction, params.frompause);
        }
    }

    getTitle() {
        if (typeof this.props.player.playerMedia !== 'undefined') {
            const title = this.props.player.playerMedia.group.common.title;
            if (
                this.props.player.serie &&
                this.props.player.serie.data &&
                this.props.player.serie.data.episodeNumber !== null
            )
                return `${this.props.player.playerMedia.group.common.extendedcommon.media.serie.title} : ${title}`;
            else return title;
        } else return '';
    }

    onUpdateSprite(outputParams) {
        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.onUpdateSprite) {
            const { playerMedia: { group: { common: { image_sprites = null } = {} } = {} } = {} } =
                outputParams;
            this.refs.nplayerControls.onUpdateSprite(image_sprites);
        }
    }

    // Only for nagra
    onUpdateLangOptions(newJsonLangs, isResumeAfterIntro = false, resumeSecond = 0) {
        const newPC = this.useNewPlayerControls();
        if (newPC && this.refs.nplayerControls && this.refs.nplayerControls.onUpdateLangOptions) {
            this.refs.nplayerControls.onUpdateLangOptions(
                newJsonLangs,
                isResumeAfterIntro,
                resumeSecond
            );
        }
        if (!newPC && this.refs.playerControls && this.refs.playerControls.onUpdateLangOptions) {
            this.refs.playerControls.onUpdateLangOptions(newJsonLangs);
        }

        console.log('[Video component] NEW LANGS>>>> ', newJsonLangs);
    }

    onUpdateCurrentTimeshift(time) {
        console.error('RDGV onUpdateCurrentTimeshift', this.state.currentTimeshiftTime);
        this.state.currentTimeshiftTime = time;
    }

    setHandleChangeSubtitle = (func) => {
        if (typeof func === 'function') this.setState({ handleChangeSubtitle: func });
    };

    livePlayingAsPip = () => {
        return AAFPlayer.livePlayingAsPip();
    };

    playingResolvedParams = () => {
        return this.AAFResolvedParams;
    };

    useNewPlayerControls() {
        let newPC = false;
        let currentContentStreamType = this.getCurrentStreamContentType();

        // En lo que se recupera el stream content type, si es live desde AAFPlayer
        // entonces se lanza el player TV en el inter
        if (!currentContentStreamType) {
            currentContentStreamType = this.nextContentStreamType;
        }

        switch (currentContentStreamType) {
            case AAF_CONTENT_IS_TV:
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
            case AAF_CONTENT_IS_NPVR:
            case AAF_CONTENT_IS_VOD:
                newPC = true;
                break;
        }

        return newPC;
    }

    getNextGroupId() {
        let gid = null;
        if (
            this.props.player &&
            this.props.player.islive &&
            this.props.player.source &&
            this.props.player.source.videoid
        ) {
            gid = this.props.player.source.videoid;
        }

        return gid;
    }

    stopPlayer() {
        const {modalRecordSeriesContent=false } = store.getState().player;

        const nullPlayer = {
            ispip: false,
            islive: true,
            playerstate: 'STOPPING',
            event: null,
            modalRecordSeriesContent,
        };
        store.dispatch(playFullMedia(nullPlayer));
    }

    /**
     *
     * Be carefull when you call this method, maybe
     * dont get what you expect when calling this
     *
     * @returns get params AAFPlayer was (last) called with
     */
    getCurrentPlayerOptions() {
        return AAFPlayer.getCurrentPlayerOptions(false);
    }

    getPlayerControls(isAudioType, isFavorite, isShuffle, isRepeat) {
        const { player: { ispreview } = {} } = this.props;
        return this.useNewPlayerControls() ? (
            <PlayerControls
                clearLoading={ () => {
                  this.clearLoading()
                  this.onChangingChannel(false)
                  const failNextOptions = store.getState().player
                  this.onResolveAsyncPinFailed(failNextOptions)
                  }
                }
                ispreview={ispreview}
                clearTimeOutAAF={this.props.clearTimeOutAAF}
                startTimeOutAAF={this.props.startTimeOutAAF}
                ref="nplayerControls"
                back={this.goBack}
                seek={this.player.seek}
                play={this.player.resume}
                pause={this.player.pause}
                doStartOver={this.doStartOver}
                onUpdateCurrentTimeshift={this.onUpdateCurrentTimeshift}
                handleFullEpg={(e) => {
                    this.handleEpg(e);
                }}
                onUpdateEpg={this.onUpdateEpg}
                speedForward={this.player.speedForward}
                speedBackward={this.player.speedBackward}
                setSpeed={this.player.setSpeed}
                goToLive={this.goToLive}
                goToCard={this.goToCard}
                isChangingChannel={this.isChangingChannel}
                checkStatusEPG={this.state.showEpg}
                groupId={this.getNextGroupId()}
                nextContentStreamType={this.nextContentStreamType}
                linealChannels={this.props.linealChannels}
                hideOnlyMini={this.hideOnlyMini}
                dataMetric={{ provider: this.props.player.provider, title: this.getTitle() }}
                setMetricsEvent={this.props.setMetricsEvent}
                playingResolvedParams={this.playingResolvedParams}
                changeLang={this.changeLang}
                serieData={this.serieData}
                controlBarIsShowed={this.controlBarIsShowed}
                // en catchup, desde el full video ya tenemos la info del programa al que vamos,
                // se envía para actualizar y posicionar la mini en catchup
                event={this.props.player.event || null}
                history={this.props.history || null}
                changeContentfromSelector={this.changeContentfromSelector}
                record={this.record}
                showPlayerEventRecordingNotAvailableNotification={
                    this._showPlayerEventRecordingNotAvailableNotification
                }
                onResultFireTPA={this.onResultFireTPA}
                stopPlayer={this.stopPlayer}
                onFireTPA={this.onFireTPA}
                getCurrentPlayerOptions={this.getCurrentPlayerOptions}
            />
        ) : (
            <PlayerControlsLegacy
                nextContentStreamType={this.nextContentStreamType}
                sendMusicMetrics={this.sendMusicMetrics}
                playFromCard={this.props.player.playFromCard || false}
                clearFallback={this.clearFallback}
                ref="playerControls"
                seek={this.player.seek}
                play={this.player.resume}
                pause={this.player.pause}
                back={this.goBack}
                record={this.record}
                enable={this.state.enableplayercontrols}
                autoPlay={true}
                autoHide={this.props.player.streamType !== playerConstant.AUDIO}
                type={
                    isAudioType !== null ? isAudioType : this.props.player.islive ? 'live' : 'vod'
                }
                serieData={this.serieData}
                handleFullEpg={(e) => {
                    this.handleEpg(e);
                }}
                handleRedirect={this.handleRedirect}
                jsonLangs={this.langOptions}
                changeLang={this.changeLang}
                onUpdateEpg={this.onUpdateEpg}
                epgGroupId={
                    this.ResolvegroupId ||
                    (this.props.player.source && this.props.player.source.videoid)
                }
                timeshiftAllowed={this.state.timeshiftAllowed}
                currentTimeshiftTime={this.state.currentTimeshiftTime}
                onUpdateCurrentTimeshift={this.onUpdateCurrentTimeshift}
                controlBarIsShowed={this.controlBarIsShowed}
                setMetricsEvent={this.props.setMetricsEvent}
                dataMetric={{ provider: this.props.player.provider, title: this.getTitle() }}
                opcFavorite={isFavorite}
                opcShuffle={isShuffle}
                opcRepeat={isRepeat}
                changeChannel={this.changeChannel}
                hideOnlyMini={this.hideOnlyMini}
                linealChannels={this.props.linealChannels}
                changeContentfromSelector={this.changeContentfromSelector}
                goToCard={this.goToCard}
                doTimeshift={this.doTimeshift}
                doStartOver={this.doStartOver}
                channelInfo={this.channelInfo}
                hideEpgOutside={this.hideEpgOutside}
                style={{ display: !this.state.showEpg ? 'block' : 'none' }}
                checkStatusEPG={this.state.showEpg}
                checkStatusCoverFlowCH={this.state.coverFlow}
                checkStatusMiniEPG={this.state.showMiniEpg}
                hasEpgError={this.hasEpgError}
                isChangingChannel={this.isChangingChannel}
                onChangingChannel={this.onChangingChannel}
                changeCurrentGroupId={this.changeCurrentGroupId}
                fromProps={this.fromProps}
                setFromProps={this.setFromProps}
                goToLive={this.goToLive}
                streamContentType={this.getCurrentStreamContentType}
                speedForward={this.player.speedForward}
                speedBackward={this.player.speedBackward}
                setSpeed={this.player.setSpeed}
                streamType={this.AAFResolvedParams && this.AAFResolvedParams.streamType}
                playingResolvedParams={this.playingResolvedParams}
                getSpriteImage={this.getSpriteImage}
                livePlayingAsPip={this.livePlayingAsPip}
                trackInfo={this.state.trackInfo}
                useNewPlayerControls={this.useNewPlayerControls}
                //launchCoverFlow={this.launchCoverFlow}
                isTPA={this.isTPA}
                tpaData={this.tpaData}
            />
        );
    }

    render() {
        console.log('[Video] render this.AllEpgs', this.AllEpgs);
        let nodeId = null;
        let updateFilter = null;
        let isAudioType = null;
        const isPlaying = this.props.player && this.props.player.playerstate === AAFPLAYER_PLAY;
        const androidIsPlaying =
            this.props.player.playerstate === undefined && this.state.androidIsPlaying;
        const isPlayingInFull =
            isPlaying &&
            this.props.player.size &&
            this.props.player.size.width &&
            this.props.player.size.width >= 1280;
        const isPlayingLiveAsFull =
            isPlayingInFull && this.props.player && this.props.player.islive;
        let filterEPG = null;
        if (this.props.player.playerstate !== AAFPLAYER_STOP) {
            filterEPG = this.state.filterEpg; //  this.props.player.filterTV;
        }
        //console.log('[EPGFILTER] Video component filterTV ',  this.props.player.filterTV);
        if (this.props.player.showEpg) {
            this.setState({ showEpg: this.props.player.showEpg });
            this.props.player.showEpg = null;
            //delete this.props.player.filterTV;
        }

        if (this.props.player.source) {
            if (this.props.player.source.hasOwnProperty('audiosource')) {
                if (this.props.player.islive) {
                    isAudioType = 'radio';
                } else {
                    isAudioType = 'audio';
                }
            }
        }

        if (window.location.search) {
            this.guideParams = Utils.urlParamsToJson(window.location.search);
        }

        if (this.guideParams && this.guideParams.url) {
            const split = this.guideParams.url.split('/');

            nodeId = split[2];
            updateFilter = true;
        }
        let isFavorite,
            isRepeat = false;
        let isShuffle = 0;

        // Need to position subtitles:
        let vClassName = '';
        if (this.isPlayerFull) {
            vClassName = 'vcontainer';
        }

        let containerMusic = <MusicContainer />;

        let subtitlesParser = (
            <VirtualSubtitles
                subtitle={this.state.subtitleparser.subtitle}
                className={this.state.subtitleparser.className}
                //getCurrentTime={this.getCurrentTime}
                setHandleChangeSubtitle={this.setHandleChangeSubtitle}
            />
        );
        if (
            this.playeIsOnScreen &&
            (isAudioType === playerConstant.AUDIO || isAudioType === playerConstant.RADIO)
        ) {
            window.SpatialNavigation.focus('.player-main-button');
            const configContent = store.dispatch(checkFavoriteContent());
            isFavorite = configContent.isFavorite;
            isShuffle = configContent.isShuffle;
            isRepeat = configContent.isRepeat;
        }

        let playerWatermark = null;

        if (AAF.Timeshift.playerWatermarkEnabled()) {
            playerWatermark = (
                <PlayerWatermark
                    id="player_watermark"
                    ref={(_ref) => {
                        this.refPlayerWatermark = _ref;
                    }}
                    imageData={{}}
                />
            );
        }

        console.info(
            '[VideoComponent] render ',
            '\nprops: ',
            this.props,
            '\nstate ',
            this.state,
            '\ncurrentTimeshiftTime',
            this.state.currentTimeshiftTime
        );

        return (
            <div ref="" className={vClassName} style={{ display: 'none' }} id={this.props.id}>
                {playerWatermark}

                {isAudioType !== null ? containerMusic : null}

                <div
                    id="HTML5VideoWrapper"
                    ref="VideoContainer"
                    className={this.props.classVideo + this.state.extraClass}
                />
                {this.state.loading && <Spinner visible={true} />}
                {Utils.getCoverFlowVisibilityFromMetadata().enable && (
                    <CoverFlow
                        channels={this.channelsPurchased}
                        current={this.current}
                        show={this.state.coverFlow}
                        onPressYellowButton={this.hideCoverFlow}
                        onPressBackButton={this.hideCoverFlow}
                        onSelect={this.onSelectCard}
                        onChangeChannel={(channel) => {
                            this.hideEpgOutside(channel.group_id, channel);
                        }}
                        channelControls={this.channelControlsEnabled}
                        onPressBlueButton={this.handleEpgCover}
                        delayCoverFlow={this.delayCoverFlow}
                        specialLoading={this.state.specialLoading}
                    />
                )}
                {!this.state.coverFlow &&
                    (EpgPersistence.isDatabaseDataSource() || isPlaying || androidIsPlaying) &&
                    this.AllEpgs &&
                    this.getPlayerControls(isAudioType, isFavorite, isShuffle, isRepeat)}
                {
                    // <FullEpgPersistance
                    //   show={this.state.showEpg ? true : false}
                    //   handleFullEpg={this.handleEpg}
                    //   filterEpg={(filterEPG) ? filterEPG : null}
                    //   hideEpgOutside={this.hideEpgOutside}
                    // />
                    <Epg
                        ref="epgControls"
                        handleFullEpg={this.handleEpg}
                        hideEpgOutside={this.hideEpgOutside}
                        onChangingChannel={this.onChangingChannel}
                        isChangingChannel={this.isChangingChannel}
                        getEpgType={this.getEpgType}
                        setEpgType={this.setEpgType}
                        hasEpgError={this.hasEpgError}
                        setEpgError={this.setEpgError}
                        groupId={
                            this.ResolvegroupId ||
                            (this.props.player.source && this.props.player.source.videoid)
                        }
                        onUpdateEpg={this.onUpdateEpg}
                        node_id={nodeId}
                        updateFilter={updateFilter}
                        goToCard={this.goToCard}
                        showEpg={this.state.epgType === 'GUIDE'}
                        //showCoverFlow={this.state.showCoverFlow}
                        epgFilter={this.props.player.showEpg ? this.props.player.showEpg : null}
                        filterEpg={filterEPG ? filterEPG : null}
                        style={{ display: this.state.showEpg ? 'block' : 'none' }}
                        checkStatusEPG={this.state.showEpg}
                        checkStatusCoverFlowCH={this.state.coverFlow}
                        record={this.record}
                        isPlayingLiveAsFull={isPlayingLiveAsFull}
                        receiveOK={this.state.receiveOK}
                        streamType={this.AAFResolvedParams && this.AAFResolvedParams.streamType}
                        streamContentType={this.getCurrentStreamContentType}
                        changeLangCb={this.changeLang}
                        getCurrentEvent={this.getCurrentEvent}
                        showFullEpg={this.showEPG}
                    />
                }

                {subtitlesParser}
            </div>
        );
    }
}

Video.propTypes = {
    src: PropTypes.string,
    controls: PropTypes.bool,
    muted: PropTypes.bool,
    fullscreen: PropTypes.bool,
    classVideo: PropTypes.string,
};

Video.defaultProps = {
    classVideo: '',
    controls: false,
    muted: false,
    fullscreen: true,
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.jsx